import _defineProperty2 from "/Users/Easy/Code/gitcode/cic/web/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "/Users/Easy/Code/gitcode/cic/web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/Users/Easy/Code/gitcode/cic/web/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _assertThisInitialized from "/Users/Easy/Code/gitcode/cic/web/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _objectSpread from "/Users/Easy/Code/gitcode/cic/web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "/Users/Easy/Code/gitcode/cic/web/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/Users/Easy/Code/gitcode/cic/web/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/Easy/Code/gitcode/cic/web/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/Easy/Code/gitcode/cic/web/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/Easy/Code/gitcode/cic/web/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/Easy/Code/gitcode/cic/web/node_modules/@babel/runtime/helpers/esm/inherits";
import React, { cloneElement, Component } from 'react';
import PropTypes from 'prop-types';
import { StyleSheet, css } from 'aphrodite/no-important';
import BigScreen from 'isomorphic-bigscreen';
import { EVENTS, createMessageHelper, ACTIONS } from 'griffith-message';
import { ua, reduce, sequence, isMSESupported, isHlsNativeSupported, logger } from 'griffith-utils';
import { parse } from 'query-string';
import noop from 'lodash/noop';
import EventEmitter from 'eventemitter3';
import elementResizeEvent from 'element-resize-event';
import debounce from 'lodash/debounce';
import clamp from 'lodash/clamp';
import memoize from 'lodash/memoize';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
} // https://github.com/zloirock/core-js/issues/280


function pad(number) {
  var result = String(number);

  if (result.length < 2) {
    result = '0' + result;
  }

  return result;
}

function formatTime(time) {
  if (!Number.isFinite(time)) return '';
  time = Math.floor(time);
  var seconds = time % 60;
  var minutes = Math.floor(time / 60);
  return "".concat(pad(minutes), ":").concat(pad(seconds));
}

var Time =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Time, _React$Component);

  function Time() {
    _classCallCheck(this, Time);

    return _possibleConstructorReturn(this, _getPrototypeOf(Time).apply(this, arguments));
  }

  _createClass(Time, [{
    key: "render",
    value: function render() {
      var value = this.props.value;
      return React.createElement("span", null, formatTime(value));
    }
  }]);

  return Time;
}(React.Component);

_defineProperty(Time, "propTypes", {
  value: PropTypes.number
});

_defineProperty(Time, "defaultProps", {
  value: 0
});

var styles = StyleSheet.create({
  root: {
    display: 'inline-block',
    width: '1.5em',
    height: '1.5em'
  },
  svg: {
    display: 'block',
    width: '100%',
    height: '100%',
    fill: 'currentColor'
  }
});

function Icon(_ref) {
  var icon = _ref.icon,
      customStyles = _ref.styles;
  var children = cloneElement(icon, {
    className: css(styles.svg)
  });
  return React.createElement("span", {
    className: css(styles.root, customStyles)
  }, children);
}

Icon.propTypes = {
  icon: PropTypes.element.isRequired
};
var alert = React.createElement("svg", {
  viewBox: "0 0 20 20"
}, React.createElement("path", {
  d: "M10 0C4.477 0 0 4.477 0 10s4.477 10 10 10 10-4.477 10-10S15.523 0 10 0zm-.034 2.966c1.95 0 1.485 1.807 1.485 2.21 0 .116-.784 7.79-.784 7.79h-1.4S8.48 5.344 8.48 5.23c0-.417-.462-2.264 1.486-2.264zm1.057 13.522c-.294.287-.647.43-1.056.43-.41 0-.762-.142-1.058-.43-.296-.286-.444-.643-.444-1.07 0-.41.148-.762.443-1.057.294-.294.647-.44 1.057-.44.41 0 .762.142 1.056.43.296.286.443.643.443 1.07 0 .426-.147.782-.443 1.068z"
}));
var pause = React.createElement("svg", {
  viewBox: "0 0 72 72"
}, React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("circle", {
  cx: "36",
  cy: "36",
  r: "36",
  fill: "#FFF",
  fillOpacity: ".95"
}), React.createElement("path", {
  fill: "#444",
  fillRule: "nonzero",
  d: "M41.143 22.5h5.786v27h-5.786zM25.071 22.5h5.786v27h-5.786z"
})));
var play = React.createElement("svg", {
  viewBox: "0 0 72 72"
}, React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("circle", {
  cx: "36",
  cy: "36",
  r: "36",
  fill: "#FFF",
  fillOpacity: ".95"
}), React.createElement("path", {
  fill: "#444",
  fillRule: "nonzero",
  d: "M50.8350169,37.0602664 L29.4767217,49.9693832 C28.900608,50.3175908 28.1558807,50.1251285 27.8133266,49.5395068 C27.701749,49.3487566 27.6428571,49.1309436 27.6428571,48.9090213 L27.6428571,23.0907876 C27.6428571,22.4094644 28.1862113,21.8571429 28.8564727,21.8571429 C29.0747919,21.8571429 29.2890685,21.9170066 29.4767217,22.0304257 L50.8350169,34.9395425 C51.4111306,35.28775 51.6004681,36.0447682 51.257914,36.6303899 C51.154433,36.8072984 51.0090531,36.9550776 50.8350169,37.0602664 Z"
})));
var replay = React.createElement("svg", {
  viewBox: "0 0 24 24"
}, React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("rect", {
  width: "24",
  height: "24"
}), React.createElement("path", {
  fill: "#FFF",
  d: "M12.4049973,3.62840003 C17.1876069,3.84468032 21,7.87252205 21,12.8096305 C21,17.8853314 16.9705627,22 12,22 C7.02943725,22 3,17.8853314 3,12.8096305 C3,12.0229797 3.624497,11.3852732 4.39485308,11.3852732 C5.16520917,11.3852732 5.78970616,12.0229797 5.78970616,12.8096305 C5.78970616,16.3120298 8.57014942,19.1512855 12,19.1512855 C15.4298506,19.1512855 18.2102938,16.3120298 18.2102938,12.8096305 C18.2102938,9.44617464 15.6460805,6.69429107 12.4049973,6.4812447 L12.4049973,8.30324795 C12.4049973,8.71101381 12.0954942,9.04157334 11.7137028,9.04157334 C11.5841406,9.04157334 11.457186,9.00268616 11.3473174,8.92934663 L6.42999892,5.64693477 C6.10624047,5.4308193 6.00781868,4.97530916 6.21016772,4.62952441 C6.26580359,4.53445089 6.34098153,4.45415835 6.42999892,4.3947374 L11.3473174,1.11232554 C11.6710759,0.896210069 12.0975703,1.00132779 12.2999193,1.34711255 C12.3685872,1.46445578 12.4049973,1.60004749 12.4049973,1.73842422 L12.4049973,3.62840003 Z"
})));
var SIZE = 64;
var BORDER = 3;
var RADIUS = (SIZE - BORDER) / 2;
var PERIMETER = 2 * Math.PI * RADIUS;
var animation = {
  '0%': {
    transform: 'rotate(0deg)'
  },
  '100%': {
    transform: 'rotate(360deg)'
  }
};
var circleAnimation = {
  '0%': {
    strokeDashoffset: PERIMETER,
    transform: 'rotate(0deg)'
  },
  '50%': {
    strokeDashoffset: PERIMETER / 4,
    transform: 'rotate(90deg)'
  },
  '100%': {
    strokeDashoffset: PERIMETER,
    transform: 'rotate(360deg)'
  }
};
var styles$1 = StyleSheet.create({
  root: {
    width: '4em',
    height: '4em'
  },
  svg: {
    display: 'block',
    width: '100%',
    height: '100%',
    animationName: animation,
    animationDuration: '2s',
    animationIterationCount: 'infinite',
    animationTimingFunction: 'linear'
  },
  circle: {
    cx: '50%',
    cy: '50%',
    r: RADIUS,
    strokeDasharray: PERIMETER,
    stroke: 'currentColor',
    strokeWidth: BORDER,
    strokeLinecap: 'round',
    fill: 'none',
    transformOrigin: 'center',
    animationName: circleAnimation,
    animationDuration: '1.5s',
    animationIterationCount: 'infinite',
    animationTimingFunction: 'ease-in-out'
  }
});

var Loader =
/*#__PURE__*/
function (_Component) {
  _inherits(Loader, _Component);

  function Loader() {
    _classCallCheck(this, Loader);

    return _possibleConstructorReturn(this, _getPrototypeOf(Loader).apply(this, arguments));
  }

  _createClass(Loader, [{
    key: "render",
    value: function render() {
      return React.createElement("div", {
        className: css(styles$1.root)
      }, React.createElement("svg", {
        viewBox: "0 0 64 64",
        className: css(styles$1.svg)
      }, React.createElement("circle", {
        className: css(styles$1.circle)
      })));
    }
  }]);

  return Loader;
}(Component);

var VideoSourceContext = React.createContext({});
VideoSourceContext.displayName = 'VideoSourceContext';
var QUALITY_ORDER = ['ld', 'sd', 'hd'];

var getQualities = function getQualities(sources, isMobile) {
  var qualities = Object.keys(sources).sort(function (a, b) {
    return QUALITY_ORDER.indexOf(a) - QUALITY_ORDER.indexOf(b);
  });

  if (qualities.length > 1) {
    if (isMobile) {
      // 移动端只返回最低清晰度
      return qualities.slice(0, 1);
    } else {
      // 桌面端端去掉低清，除非只有一个低清
      return qualities.filter(function (item) {
        return item !== 'ld';
      });
    }
  }

  return qualities;
};

var getSources = function getSources(qualities, sources) {
  return qualities.map(function (quality) {
    var _sources$quality = sources[quality],
        play_url = _sources$quality.play_url,
        rest = _objectWithoutProperties(_sources$quality, ["play_url"]);

    return _objectSpread({}, rest, {
      source: play_url,
      quality: quality
    });
  });
};

var isMobile = ua.isMobile;

var VideoSourceProvider =
/*#__PURE__*/
function (_React$Component2) {
  _inherits(VideoSourceProvider, _React$Component2);

  function VideoSourceProvider() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, VideoSourceProvider);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(VideoSourceProvider)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      qualities: [],
      currentQuality: null,
      format: null,
      sources: [],
      expiration: 0,
      dataKey: null
    });

    _defineProperty(_assertThisInitialized(_this), "setCurrentQuality", function (quality) {
      var prevQuality = _this.state.currentQuality;

      if (prevQuality !== quality) {
        _this.setState({
          currentQuality: quality
        });

        _this.props.onEvent(EVENTS.PLAYER.QUALITY_CHANGE, {
          prevQuality: prevQuality,
          quality: quality
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "getCurrentSrc", function () {
      var _this$state = _this.state,
          currentQuality = _this$state.currentQuality,
          sources = _this$state.sources;

      if (sources.length === 0) {
        return;
      }

      var source = sources.find(function (item) {
        return item.quality === currentQuality;
      }) || sources[0];
      return source.source;
    });

    return _this;
  }

  _createClass(VideoSourceProvider, [{
    key: "render",
    value: function render() {
      var _this$state2 = this.state,
          qualities = _this$state2.qualities,
          currentQuality = _this$state2.currentQuality,
          format = _this$state2.format,
          dataKey = _this$state2.dataKey,
          sources = _this$state2.sources;
      return React.createElement(VideoSourceContext.Provider, {
        value: {
          dataKey: dataKey,
          qualities: qualities,
          format: format,
          sources: sources,
          currentQuality: currentQuality,
          currentSrc: this.getCurrentSrc(),
          setCurrentQuality: this.setCurrentQuality
        }
      }, this.props.children);
    }
  }]);

  return VideoSourceProvider;
}(React.Component);

_defineProperty(VideoSourceProvider, "propTypes", {
  onEvent: PropTypes.func.isRequired,
  sources: PropTypes.object,
  id: PropTypes.string.isRequired
});

_defineProperty(VideoSourceProvider, "getDerivedStateFromProps", function (_ref2, state) {
  var videoSources = _ref2.sources,
      id = _ref2.id;
  if (!videoSources) return null;
  var _Object$values$ = Object.values(videoSources)[0],
      format = _Object$values$.format,
      play_url = _Object$values$.play_url;

  var _parse = parse(play_url),
      expiration = _parse.expiration;

  var dataKey = "".concat(id, "-").concat(expiration); // expiration 和 id 组合可以唯一标识一次请求的数据

  if (dataKey == state.dataKey) return null;
  var qualities = getQualities(videoSources, isMobile);
  var sources = getSources(qualities, videoSources);

  if (!isMobile && format === 'm3u8') {
    qualities.unshift('auto');
  }

  var currentQuality = state.currentQuality || qualities[0];
  return {
    currentQuality: currentQuality,
    qualities: qualities,
    sources: sources,
    format: format,
    expiration: Number(expiration),
    dataKey: dataKey
  };
});

var EVENT_TYPE = 'event';
var ACTION_TYPE = 'action';
/**
 * 用于播放器内部，只能接收外界传入的 Action，向外界发出 Event
 */

var InternalContext = React.createContext({});
InternalContext.displayName = 'InternalMessageContext';
/**
 * 用于播放器外部，只能接收播放器发出的 Event, 或者向播放器发送 Action
 */

var ExternalContext = React.createContext({});
ExternalContext.displayName = 'ExternalMessageContext';

var MessageProvider =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(MessageProvider, _React$PureComponent);

  function MessageProvider(props) {
    var _this2;

    _classCallCheck(this, MessageProvider);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(MessageProvider).call(this, props));

    _defineProperty(_assertThisInitialized(_this2), "emitEvent", function (eventName, data) {
      _this2.emitter.emit(eventName, {
        __type__: EVENT_TYPE,
        data: data
      });

      if (_this2.props.enableCrossWindow) {
        _this2.dispatchCrossWindowMessage(window.parent, eventName, data);
      }
    });

    _defineProperty(_assertThisInitialized(_this2), "subscribeEvent", function (eventName, listener) {
      var realLisener = function realLisener() {
        var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            __type__ = _ref3.__type__,
            data = _ref3.data;

        if (__type__ === EVENT_TYPE) {
          listener(data);
        }
      };

      _this2.emitter.on(eventName, realLisener);

      return {
        unsubscribe: function unsubscribe() {
          return _this2.emitter.off(eventName, realLisener);
        }
      };
    });

    _defineProperty(_assertThisInitialized(_this2), "dispatchAction", function (actionName, data) {
      _this2.emitter.emit(actionName, {
        __type__: ACTION_TYPE,
        data: data
      });
    });

    _defineProperty(_assertThisInitialized(_this2), "subscribeAction", function (eventName, listener) {
      var realLisener = function realLisener(_ref4) {
        var __type__ = _ref4.__type__,
            data = _ref4.data;

        if (__type__ === ACTION_TYPE) {
          listener(data);
        }
      };

      _this2.emitter.on(eventName, realLisener);

      return {
        unsubscribe: function unsubscribe() {
          return _this2.emitter.off(eventName, realLisener);
        }
      };
    });

    _this2.emitter = new EventEmitter();
    var _this2$props = _this2.props,
        id = _this2$props.id,
        targetOrigin = _this2$props.targetOrigin;

    var _createMessageHelper = createMessageHelper(id, targetOrigin),
        subscribeMessage = _createMessageHelper.subscribeMessage,
        dispatchMessage = _createMessageHelper.dispatchMessage;

    _this2.subscribeCrossWindowMessage = subscribeMessage;
    _this2.dispatchCrossWindowMessage = dispatchMessage;
    return _this2;
  }

  _createClass(MessageProvider, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.enableCrossWindow) {
        this.crossWindowMessageSubscription = this.subscribeCrossWindowMessage(this.dispatchAction);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.crossWindowEventSubscription) {
        this.crossWindowEventSubscription.unsubscribe();
      }
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(InternalContext.Provider, {
        value: {
          emitEvent: this.emitEvent,
          subscribeAction: this.subscribeAction
        }
      }, React.createElement(ExternalContext.Provider, {
        value: {
          dispatchAction: this.dispatchAction,
          subscribeEvent: this.subscribeEvent
        }
      }, this.props.children));
    }
  }]);

  return MessageProvider;
}(React.PureComponent);

_defineProperty(MessageProvider, "propsTypes", {
  id: PropTypes.string.isRequired,
  enableCrossWindow: PropTypes.bool,
  targetOrigin: PropTypes.string.isRequired
});

_defineProperty(MessageProvider, "defaultProps", {
  targetOrigin: '*'
});

var ObjectFitContext = React.createContext({});
ObjectFitContext.displayName = 'ObjectFitContext';
var VALID_FIT = ['fill', 'contain', 'cover', 'none', 'scale-down'];

var ObjectFitProvider =
/*#__PURE__*/
function (_React$Component3) {
  _inherits(ObjectFitProvider, _React$Component3);

  function ObjectFitProvider() {
    var _getPrototypeOf3;

    var _this3;

    _classCallCheck(this, ObjectFitProvider);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this3 = _possibleConstructorReturn(this, (_getPrototypeOf3 = _getPrototypeOf(ObjectFitProvider)).call.apply(_getPrototypeOf3, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this3), "state", {
      objectFit: _this3.props.initialObjectFit
    });

    _defineProperty(_assertThisInitialized(_this3), "setObjectFit", function (objectFit) {
      if (VALID_FIT.includes(objectFit) && _this3.state.objectFit !== objectFit) {
        _this3.setState({
          objectFit: objectFit
        });
      }
    });

    return _this3;
  }

  _createClass(ObjectFitProvider, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var initialObjectFit = this.props.initialObjectFit;

      if (initialObjectFit !== prevProps.initialObjectFit) {
        this.setObjectFit(initialObjectFit);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var objectFit = this.state.objectFit;
      return React.createElement(ObjectFitContext.Provider, {
        value: {
          objectFit: objectFit,
          setObjectFit: this.setObjectFit
        }
      }, this.props.children);
    }
  }]);

  return ObjectFitProvider;
}(React.Component);

_defineProperty(ObjectFitProvider, "propTypes", {
  initialObjectFit: PropTypes.oneOf(VALID_FIT).isRequired
});

_defineProperty(ObjectFitProvider, "defaultProps", {
  initialObjectFit: 'contain'
});

var PositionContext = React.createContext({
  isFullWidth: false
});
PositionContext.displayName = 'PositionContext';
var styles$2 = StyleSheet.create({
  root: {
    position: 'relative',
    width: '100%',
    height: '100%'
  }
});

var PositionProvider =
/*#__PURE__*/
function (_React$PureComponent2) {
  _inherits(PositionProvider, _React$PureComponent2);

  function PositionProvider() {
    var _getPrototypeOf4;

    var _this4;

    _classCallCheck(this, PositionProvider);

    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    _this4 = _possibleConstructorReturn(this, (_getPrototypeOf4 = _getPrototypeOf(PositionProvider)).call.apply(_getPrototypeOf4, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this4), "state", {
      videoWidth: 0,
      videoHeight: 0,
      isFullWidth: false,
      helperImageSrc: null
    });

    _defineProperty(_assertThisInitialized(_this4), "ref", React.createRef());

    _defineProperty(_assertThisInitialized(_this4), "startObservingResize", function () {
      var root = _this4.ref.current;

      if (root) {
        elementResizeEvent(root, _this4.updateIsFullWidth);
      }
    });

    _defineProperty(_assertThisInitialized(_this4), "updateHelperImageSrc", function () {
      var _this4$state = _this4.state,
          videoWidth = _this4$state.videoWidth,
          videoHeight = _this4$state.videoHeight;

      if (!videoWidth || !videoHeight) {
        return;
      }

      var _reduce = reduce(videoWidth, videoHeight),
          _reduce2 = _slicedToArray(_reduce, 2),
          width = _reduce2[0],
          height = _reduce2[1];

      var canvas = document.createElement('canvas');
      canvas.width = width;
      canvas.height = height;
      var helperImageSrc = canvas.toDataURL();

      _this4.setState({
        helperImageSrc: helperImageSrc
      });
    });

    _defineProperty(_assertThisInitialized(_this4), "updateIsFullWidth", function () {
      var _this4$state2 = _this4.state,
          videoWidth = _this4$state2.videoWidth,
          videoHeight = _this4$state2.videoHeight;

      if (!videoWidth || !videoHeight) {
        return;
      }

      var root = _this4.ref.current;
      if (!root) return;

      var _root$getBoundingClie = root.getBoundingClientRect(),
          width = _root$getBoundingClie.width,
          height = _root$getBoundingClie.height; // 因为视频缩放后，长宽可能不严格相等，所以认为差值小于等于 0.01 的就算相等。
      // 比如 1280x720 (1.777777778) 和 848x478 (1.774058577)，认为相等。


      var isFullWidth = width / height - videoWidth / videoHeight <= 0.01;

      if (isFullWidth !== _this4.state.isFullWidth) {
        _this4.setState({
          isFullWidth: isFullWidth
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this4), "triggerUpdateIsFullWidth", function () {
      return requestAnimationFrame(_this4.updateIsFullWidth);
    });

    _defineProperty(_assertThisInitialized(_this4), "updateVideoSize", function (_ref5) {
      var videoWidth = _ref5.videoWidth,
          videoHeight = _ref5.videoHeight;

      _this4.setState({
        videoWidth: videoWidth,
        videoHeight: videoHeight
      });
    });

    return _this4;
  }

  _createClass(PositionProvider, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.shouldObserveResize) {
        this.startObservingResize();
      }

      this.triggerUpdateIsFullWidth();
      this.updateHelperImageSrc();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var prevShouldObserve = prevProps.shouldObserveResize;
      var prevWidth = prevState.videoWidth,
          prevHeight = prevState.videoHeight;
      var shouldObserveResize = this.props.shouldObserveResize;
      var _this$state3 = this.state,
          videoWidth = _this$state3.videoWidth,
          videoHeight = _this$state3.videoHeight;

      if (prevWidth !== videoWidth || prevHeight !== videoHeight) {
        this.triggerUpdateIsFullWidth();
        this.updateHelperImageSrc();
      }

      if (!prevShouldObserve && shouldObserveResize) {
        this.startObservingResize();
      }

      if (prevShouldObserve && !shouldObserveResize) {
        this.stopObservingResize();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.stopObservingResize();
    }
  }, {
    key: "stopObservingResize",
    value: function stopObservingResize() {
      var root = this.ref.current;

      if (root) {
        elementResizeEvent.unbind(root);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      var _this$state4 = this.state,
          isFullWidth = _this$state4.isFullWidth,
          helperImageSrc = _this$state4.helperImageSrc;
      return React.createElement(PositionContext.Provider, {
        value: {
          isFullWidth: isFullWidth,
          helperImageSrc: helperImageSrc,
          updateVideoSize: this.updateVideoSize
        }
      }, React.createElement("div", {
        className: css(styles$2.root),
        ref: this.ref
      }, children));
    }
  }]);

  return PositionProvider;
}(React.PureComponent);

_defineProperty(PositionProvider, "propTypes", {
  shouldObserveResize: PropTypes.bool
});

var eventMap = [[EVENTS.DOM.PLAY, 'onPlay'], [EVENTS.DOM.PLAYING, 'onPlaying'], [EVENTS.DOM.PAUSE, 'onPause'], [EVENTS.DOM.ENDED, 'onEnded'], [EVENTS.DOM.TIMEUPDATE, 'onTimeUpdate'], [EVENTS.DOM.ERROR, 'onError'], [EVENTS.DOM.WAITING, 'onWaiting']];

function serializeDOMException(exception) {
  if (!exception) return null;
  var code = exception.code,
      messge = exception.messge,
      name = exception.name;
  return {
    code: code,
    messge: messge,
    name: name
  };
}

function getMediaEventPayload(event) {
  var _event$currentTarget = event.currentTarget,
      currentTime = _event$currentTarget.currentTime,
      duration = _event$currentTarget.duration,
      error = _event$currentTarget.error;
  return {
    currentTime: currentTime,
    duration: duration,
    error: serializeDOMException(error)
  };
}

var VideoWithMessage = React.forwardRef(function (props, ref) {
  var renderChildren = function renderChildren(emitEvent, objectFit, updateVideoSize) {
    var newProps = {};
    eventMap.map(function (_ref6) {
      var _ref7 = _slicedToArray(_ref6, 2),
          eventName = _ref7[0],
          key = _ref7[1];

      var handler = props[key];

      var emit = function emit(event) {
        return emitEvent(eventName, getMediaEventPayload(event));
      };

      newProps[key] = sequence(emit, handler || noop);
    });

    var updateVideoSizeOnLoadedMetadata = function updateVideoSizeOnLoadedMetadata(event) {
      var videoNode = event.currentTarget;

      if (videoNode) {
        var videoWidth = videoNode.videoWidth,
            videoHeight = videoNode.videoHeight;
        updateVideoSize({
          videoWidth: videoWidth,
          videoHeight: videoHeight
        });
      }
    };

    var newOnLoadedMetadata = sequence(updateVideoSizeOnLoadedMetadata, props.onLoadedMetadata || noop);

    var Video = props.Video,
        otherProps = _objectWithoutProperties(props, ["Video"]);

    return React.createElement(Video, _extends({}, otherProps, newProps, {
      ref: ref,
      style: {
        objectFit: objectFit
      },
      onLoadedMetadata: newOnLoadedMetadata
    }));
  };

  return React.createElement(PositionContext.Consumer, null, function (_ref8) {
    var updateVideoSize = _ref8.updateVideoSize;
    return React.createElement(ObjectFitContext.Consumer, null, function (_ref9) {
      var objectFit = _ref9.objectFit;
      return React.createElement(InternalContext.Consumer, null, function (_ref10) {
        var emitEvent = _ref10.emitEvent;
        return renderChildren(emitEvent, objectFit, updateVideoSize);
      });
    });
  });
});

var NormalVideo = function NormalVideo(_ref11) {
  var onRef = _ref11.onRef,
      paused = _ref11.paused,
      currentQuality = _ref11.currentQuality,
      sources = _ref11.sources,
      props = _objectWithoutProperties(_ref11, ["onRef", "paused", "currentQuality", "sources"]);

  return React.createElement("video", _extends({}, props, {
    ref: onRef
  }));
};

var NormalVideo$1 = {
  pluginName: 'native',
  VideoComponent: NormalVideo
};
/* global __WITHOUT_HLSJS__:false, __WITHOUT_MP4__:false */

function selectVideo(format, useMSE) {
  if (format === 'm3u8') {
    if (typeof __WITHOUT_HLSJS__ === 'undefined' ? false : __WITHOUT_HLSJS__) {
      return NormalVideo$1;
    } else if (isMSESupported() && !isHlsNativeSupported()) {
      return require('griffith-hls').default;
    }
  }

  if (format === 'mp4') {
    if (typeof __WITHOUT_MP4__ === 'undefined' ? false : __WITHOUT_MP4__) {
      return NormalVideo$1;
    } else if (isMSESupported() && useMSE) {
      return require('griffith-mp4').default;
    }
  }

  return NormalVideo$1;
}

var styles$3 = StyleSheet.create({
  root: {
    display: 'block',
    width: '100%',
    height: '100%'
  }
});
var isMobile$1 = ua.isMobile;

var isAbortError = function isAbortError(error) {
  return error && error.name === 'AbortError' || error instanceof MediaError && error.code === MediaError.MEDIA_ERR_ABORTED;
};

var isNotAllowedError = function isNotAllowedError(error) {
  return error && error.name === 'NotAllowedError';
};

var Video =
/*#__PURE__*/
function (_Component2) {
  _inherits(Video, _Component2);

  function Video() {
    var _getPrototypeOf5;

    var _this5;

    _classCallCheck(this, Video);

    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    _this5 = _possibleConstructorReturn(this, (_getPrototypeOf5 = _getPrototypeOf(Video)).call.apply(_getPrototypeOf5, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this5), "isMetadataLoaded", false);

    _defineProperty(_assertThisInitialized(_this5), "pendingAction", null);

    _defineProperty(_assertThisInitialized(_this5), "loading", false);

    _defineProperty(_assertThisInitialized(_this5), "root", null);

    _defineProperty(_assertThisInitialized(_this5), "safeExecute", function (fn) {
      if (_this5.playPromise !== undefined) {
        _this5.playPromise.then(function () {
          fn();
        });
      } else {
        fn();
      }
    });

    _defineProperty(_assertThisInitialized(_this5), "handleMetadataLoaded", function () {
      _this5.isMetadataLoaded = true;

      _this5.applyPendingAction();
    });

    _defineProperty(_assertThisInitialized(_this5), "handleError", function () {
      var onError = _this5.props.onError;

      if (onError) {
        onError(_this5.root.error);
      }
    });

    _defineProperty(_assertThisInitialized(_this5), "handleDurationChange", function () {
      var onDurationChange = _this5.props.onDurationChange;

      if (onDurationChange) {
        onDurationChange(_this5.root.duration);
      }
    });

    _defineProperty(_assertThisInitialized(_this5), "handleWaiting", function () {
      if (!_this5.loading) {
        _this5.loading = true;
      }

      _this5.props.onWaiting();
    });

    _defineProperty(_assertThisInitialized(_this5), "handlePlaying", function () {
      if (_this5.loading) {
        _this5.loading = false;
      }

      _this5.props.onPlaying();
    });

    _defineProperty(_assertThisInitialized(_this5), "handleTimeUpdate", function (arg) {
      var _this5$props = _this5.props,
          onTimeUpdate = _this5$props.onTimeUpdate,
          paused = _this5$props.paused;

      _this5.disposeTimer();

      if (paused || _this5.loading) {
        return;
      }

      var _ref12 = _this5.root || {},
          currentTime = _ref12.currentTime;

      if (onTimeUpdate && currentTime) {
        var isRaf = typeof arg === 'number'; // raf 调用 arg 是 时间戳，事件监听调用 arg 是 event

        onTimeUpdate(currentTime, isRaf);

        if (!isMobile$1) {
          // 移动端使用原生进度条，不需要频繁更新，减少性能压力
          _this5._playTimer = window.requestAnimationFrame(_this5.handleTimeUpdate);
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this5), "handleVolumeChange", function () {
      var onVolumeChange = _this5.props.onVolumeChange;

      if (onVolumeChange) {
        onVolumeChange(_this5.root.muted ? 0 : Math.sqrt(_this5.root.volume));
      }
    });

    _defineProperty(_assertThisInitialized(_this5), "handleProgress", function () {
      var onProgress = _this5.props.onProgress;
      var buffered = _this5.root.buffered;
      var result = [];

      for (var i = 0; i < buffered.length; i++) {
        result.push({
          start: buffered.start(i),
          end: buffered.end(i)
        });
      }

      if (onProgress) {
        onProgress(result);
      }
    });

    _defineProperty(_assertThisInitialized(_this5), "handleError", function () {
      var _ref13 = _this5.root || {},
          error = _ref13.error,
          currentTime = _ref13.currentTime;

      if (!error) {
        return;
      }

      var code = error.code,
          message = error.message,
          name = error.name;
      logger.debug('Error: %o', {
        code: code,
        message: message,
        name: name
      });
      var dontReportPlayFailed = isNotAllowedError(error) || isAbortError(error); // 这两种错误不认为是播放失败

      if (!dontReportPlayFailed) {
        _this5.props.onEvent(EVENTS.PLAYER.PLAY_FAILED, {
          currentTime: currentTime
        });
      }

      _this5.props.onError(error);
    });

    return _this5;
  }

  _createClass(Video, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.root.volume = Math.pow(this.props.volume, 2);
    }
  }, {
    key: "getSnapshotBeforeUpdate",
    value: function getSnapshotBeforeUpdate() {
      return {
        paused: this.root.paused,
        currentTime: this.root.currentTime
      };
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      var _this6 = this;

      var _this$props = this.props,
          src = _this$props.src,
          paused = _this$props.paused,
          volume = _this$props.volume,
          format = _this$props.format,
          useMSE = _this$props.useMSE;
      /**
       * 切换清晰度，如果是非 mse 视频（src 是 blob 类型）
       * data 变化的时候会 remount，所以 componentDidUpdate 中 src 变化一定是清晰度变了
       */

      if (prevProps.src && src !== prevProps.src) {
        var _selectVideo = selectVideo(format, useMSE),
            willHandleSrcChange = _selectVideo.willHandleSrcChange; // TODO 这一块逻辑需要 Video 自己处理


        if (!willHandleSrcChange) {
          this.safeExecute(function () {
            _this6.isMetadataLoaded = false;

            _this6.seek(snapshot.currentTime);

            if (!snapshot.paused) {
              _this6.play();
            }
          });
        }
      }

      if (paused !== prevProps.paused && paused !== this.root.paused) {
        if (paused) {
          this.pause();
        } else {
          this.play();
        }
      }

      if (this.root.volume !== Math.pow(volume, 2)) {
        this.root.volume = Math.pow(volume, 2);
      }
    }
  }, {
    key: "pending",
    value: function pending(action) {
      this.pendingAction = _objectSpread({}, this.pendingAction, {}, action);
    }
  }, {
    key: "applyPendingAction",
    value: function applyPendingAction() {
      if (!this.pendingAction) {
        return;
      }

      var action = this.pendingAction;
      this.pendingAction = null;

      if (action.currentTime !== undefined) {
        this.seek(action.currentTime);
      }

      if (action.paused !== undefined && action.paused !== this.root.paused) {
        if (action.paused) {
          this.pause();
        } else {
          this.play();
        }
      }
    }
    /**
     * @see https://developers.google.com/web/updates/2017/06/play-request-was-interrupted
     */

  }, {
    key: "play",
    value: function play() {
      var _this7 = this;

      if (!isMobile$1 && !this.isMetadataLoaded) {
        this.pending({
          paused: false
        });

        if (this.root.load) {
          // workaround for some devices that not support preload="metadata"
          this.safeExecute(function () {
            return _this7.root.load();
          });
        }

        return;
      }

      this.playPromise = Promise.resolve(this.root.play()) // 保证是 promise
      .catch(function (error) {
        var onError = _this7.props.onError;

        if (onError) {
          onError(error);
        }
      });
    }
  }, {
    key: "pause",
    value: function pause() {
      var _this8 = this;

      if (!isMobile$1 && !this.isMetadataLoaded) {
        this.pending({
          paused: true
        });
        return;
      }

      this.safeExecute(function () {
        return _this8.root.pause();
      });
    }
  }, {
    key: "seek",
    value: function seek(currentTime) {
      if (!Number.isFinite(currentTime)) return;

      if (!this.isMetadataLoaded) {
        this.pending({
          currentTime: currentTime
        });
        return;
      } // see https://stackoverflow.com/a/23353005


      if (this.root.duration) {
        this.root.currentTime = currentTime;
      }
    }
  }, {
    key: "disposeTimer",
    value: function disposeTimer() {
      window.cancelAnimationFrame(this._playTimer);
    }
  }, {
    key: "render",
    value: function render() {
      var _this9 = this;

      var _this$props2 = this.props,
          src = _this$props2.src,
          controls = _this$props2.controls,
          paused = _this$props2.paused,
          volume = _this$props2.volume,
          onPlay = _this$props2.onPlay,
          onPause = _this$props2.onPause,
          onEnded = _this$props2.onEnded,
          onLoadedData = _this$props2.onLoadedData,
          onSeeking = _this$props2.onSeeking,
          onSeeked = _this$props2.onSeeked,
          format = _this$props2.format,
          useMSE = _this$props2.useMSE,
          sources = _this$props2.sources,
          currentQuality = _this$props2.currentQuality;

      var _selectVideo2 = selectVideo(format, useMSE),
          VideoComponent = _selectVideo2.VideoComponent;

      return React.createElement(VideoWithMessage, {
        onRef: function onRef(node) {
          _this9.root = node;
        },
        className: css(styles$3.root),
        preload: "metadata",
        playsInline: true,
        "webkit-playsinline": "",
        "x-webkit-airplay": "deny",
        muted: !volume,
        controls: controls,
        src: src,
        onPlay: onPlay,
        onPause: onPause,
        onEnded: onEnded,
        onLoadedData: onLoadedData,
        onSeeking: onSeeking,
        onSeeked: onSeeked,
        onClick: this.handleClick,
        onLoadedMetadata: this.handleMetadataLoaded,
        onError: this.handleError,
        onDurationChange: this.handleDurationChange,
        onTimeUpdate: this.handleTimeUpdate,
        onVolumeChange: this.handleVolumeChange,
        onProgress: this.handleProgress,
        onWaiting: this.handleWaiting,
        onPlaying: this.handlePlaying,
        paused: paused,
        sources: sources,
        currentQuality: currentQuality,
        Video: VideoComponent
      });
    }
  }]);

  return Video;
}(Component);

_defineProperty(Video, "propTypes", {
  controls: PropTypes.bool,
  paused: PropTypes.bool,
  volume: PropTypes.number,
  onPlay: PropTypes.func,
  onPause: PropTypes.func,
  onEnded: PropTypes.func,
  onLoadedData: PropTypes.func,
  onDurationChange: PropTypes.func,
  onTimeUpdate: PropTypes.func,
  onWaiting: PropTypes.func,
  onPlaying: PropTypes.func,
  onSeeking: PropTypes.func,
  onSeeked: PropTypes.func,
  onVolumeChange: PropTypes.func,
  onProgress: PropTypes.func,
  onError: PropTypes.func.isRequired,
  onEvent: PropTypes.func.isRequired
});

_defineProperty(Video, "defaultProps", {
  src: null,
  paused: true,
  volume: 0.5
});

var Video$1 = React.forwardRef(function (props, ref) {
  return React.createElement(VideoSourceContext.Consumer, null, function (_ref14) {
    var currentSrc = _ref14.currentSrc,
        sources = _ref14.sources,
        currentQuality = _ref14.currentQuality,
        format = _ref14.format;
    return React.createElement(Video, _extends({
      ref: ref
    }, props, {
      src: currentSrc,
      format: format,
      sources: sources,
      currentQuality: currentQuality
    }));
  });
});
var KeyCode = {
  ENTER: 13,
  SPACE: 32,
  LEFT: 37,
  UP: 38,
  RIGHT: 39,
  DOWN: 40,
  ZERO: 48,
  ONE: 49,
  TWO: 50,
  THREE: 51,
  FOUR: 52,
  FIVE: 53,
  SIX: 54,
  SEVEN: 55,
  EIGHT: 56,
  NINE: 57,
  F: 70,
  J: 74,
  K: 75,
  L: 76,
  M: 77
};
var styles$4 = StyleSheet.create({
  root: {
    display: 'flex',
    alignItems: 'center',
    height: '2.5em',
    padding: '0 0.5em'
  },
  button: {
    display: 'block',
    width: '2.5em',
    height: '2.5em',
    margin: 0,
    padding: '0.5em',
    border: 'none',
    borderRadius: 0,
    fontSize: 'inherit',
    color: 'rgba(255, 255, 255, 0.7)',
    background: 'none',
    cursor: 'pointer',
    transition: 'color 300ms',
    ':hover': {
      color: '#fff'
    },
    ':focus': {
      outline: 'none'
    }
  },
  menuContainer: {
    position: 'relative'
  },
  menu: {
    position: 'absolute',
    left: '50%',
    bottom: '100%',
    visibility: 'hidden',
    opacity: 0,
    transform: 'translateX(-50%)',
    transition: 'visibility 300ms, opacity 300ms',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    borderRadius: '4px'
  },
  menuShown: {
    visibility: 'visible',
    opacity: 1
  },
  timeline: {
    flex: 1
  },
  time: {
    padding: '0 0.5em',
    width: '100px',
    textAlign: 'center',
    fontSize: '0.875em',
    lineHeight: 2.5,
    color: 'rgba(255, 255, 255, 0.9)'
  },
  qualityButton: {
    width: 'auto',
    lineHeight: 1.5
  },
  qualityButtonText: {
    fontSize: '0.875em'
  },
  qualityMenu: {
    padding: '0.25em 0'
  },
  qualityMenuItem: {
    display: 'block',
    height: '2em',
    margin: 0,
    padding: '0 0.75em',
    border: 'none',
    borderRadius: 0,
    fontSize: '0.875em',
    lineHeight: 2,
    whiteSpace: 'nowrap',
    color: 'rgba(255, 255, 255, 0.5)',
    background: 'none',
    cursor: 'pointer',
    transition: 'color 300ms, background-color 300ms',
    ':hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.2)'
    },
    ':focus': {
      outline: 'none'
    }
  },
  qualityMenuActiveItem: {
    color: '#fff'
  },
  fullScreenTooltip: {
    pointerEvents: 'none'
  },
  fullScreenedTime: {
    width: '150px'
  },
  fullScreenTooltipWide: {
    left: '30%'
  }
});
var fullscreen = React.createElement("svg", {
  viewBox: "0 0 24 24"
}, React.createElement("path", {
  d: "M20,10 L20,5 C20,4.44771525 19.5490248,4 19.009222,4 L14,4 L14,6 L18,6 L18,10 L20,10 Z M19.7115371,19.7068284 C19.8902571,19.5277733 20,19.2813055 20,19.009222 L20,14 L18,14 L18,18 L14,18 L14,20 L19.009222,20 C19.2776249,20 19.5240668,19.8893106 19.7040291,19.7101145 L19.7115371,19.7068284 Z M6,18 L6,14 L4,14 L4,19.009222 C4,19.2813055 4.10974288,19.5277733 4.28846285,19.7068284 C4.47593315,19.8893106 4.72237506,20 4.99077797,20 L10,20 L10,18 L6,18 Z M4.28846285,4.29317155 C4.10974288,4.47222673 4,4.71869448 4,4.99077797 L4,10 L6,10 L6,6 L10,6 L10,4 L4.99077797,4 C4.72237506,4 4.47593315,4.11068941 4.29597088,4.28988548 L4.28846285,4.29317155 Z"
}));
var muted = React.createElement("svg", {
  viewBox: "0 0 24 24"
}, React.createElement("path", {
  d: "M7.38001507,9.5 L5,9.5 L5,12.0119396 L5,14.5238791 L8.33098415,14.5238791 L8.33098415,14.5238791 C8.39017333,14.520451 8.4497727,14.5223174 8.50904598,14.5296109 C8.72475585,14.5524598 8.91816198,14.6424266 9.06920843,14.7779841 L13,17.4293365 L13,15.1199849 L7.38001507,9.5 Z M15,17.1199849 L15,19.251289 C15,19.8045373 14.5522847,20.25 14,20.25 C13.98423,20.25 13.9685502,20.2496405 13.9529683,20.2489292 C13.7472793,20.2584936 13.5372091,20.2041245 13.3535806,20.0802655 L8.08102098,16.5238791 L4.00000001,16.5238791 C3.71994909,16.5238791 3.46994918,16.4119504 3.29196292,16.2310404 C3.11117675,16.0497507 3,15.7991447 3,15.5223056 L3,12.0119396 L3,8.50157356 C3,8.2247344 3.11117675,7.97412842 3.29196292,7.79283868 C3.46994918,7.61192872 3.71994909,7.5 4.00000001,7.5 L5.38001507,7.5 L3.38382011,5.50380504 C2.99233448,5.1123194 2.98883249,4.48109777 3.38207944,4.08785081 C3.77260374,3.69732652 4.3999302,3.691488 4.79803367,4.08959148 L18.936688,18.2282458 C19.3281736,18.6197314 19.3316756,19.250953 18.9384286,19.6442 C18.5479043,20.0347243 17.9205779,20.0405628 17.5224744,19.6424593 L15,17.1199849 Z M10.792179,8.08373676 L9.35149599,6.64305379 L13.3535806,3.94361361 C13.5372091,3.81975463 13.7472793,3.76538554 13.9529683,3.77494994 C13.9685502,3.77423867 13.98423,3.77387913 14,3.77387913 C14.5522847,3.77387913 15,4.21934183 15,4.77259008 L15,12.0119396 L15,12.2915578 L13,10.2915578 L13,6.59454265 L10.792179,8.08373676 Z M18.0173138,15.3088716 C18.8917509,14.408489 19.4301566,13.1799808 19.4301566,11.8257212 C19.4301566,10.2214787 18.6746368,8.79369726 17.5,7.87877967 L17.5067574,7.87009164 C17.2041341,7.69816923 17,7.37292366 17,7 C17,6.44771525 17.4477153,6 18,6 C18.2836948,6 18.5397977,6.11813499 18.721799,6.30789526 L18.7279374,6.30000305 C20.3724289,7.58088767 21.4301566,9.57978168 21.4301566,11.8257212 C21.4301566,13.7322659 20.6679517,15.4607882 19.431636,16.7231938 L18.0173138,15.3088716 Z"
}));
var pause$1 = React.createElement("svg", {
  viewBox: "0 0 24 24"
}, React.createElement("path", {
  d: "M9,5 C10,5 10,6 10,6 C10,6 10,17 10,18 C10,19 9,19 9,19 L7,19 C6,19 6,18 6,18 L6,6 C6,5 7,5 7,5 C7,5 8,5 9,5 Z M17,5 C18,5 18,6 18,6 C18,6 18,17 18,18 C18,19 17,19 17,19 L15,19 C14,19 14,18 14,18 L14,6 C14,5 15,5 15,5 C15,5 16,5 17,5 Z"
}));
var play$1 = React.createElement("svg", {
  viewBox: "0 0 24 24"
}, React.createElement("path", {
  d: "M8.03610236,19.7012935 C6.93281899,20.3993842 6,19.8347521 6,18.4154722 L6,5.59575582 C6,4.14567779 6.91151094,3.59901121 8.03610236,4.30993442 L18.1645278,10.7185093 C19.2678112,11.4166 19.2891193,12.5817954 18.1645278,13.2927186 L8.03610236,19.7012935 Z"
}));
var smallscreen = React.createElement("svg", {
  viewBox: "0 0 24 24"
}, React.createElement("path", {
  d: "M14.2884629,14.2931716 C14.1097429,14.4722267 14,14.7186945 14,14.990778 L14,20 L16,20 L16,16 L20,16 L20,14 L14.990778,14 C14.7223751,14 14.4759332,14.1106894 14.2959709,14.2898855 L14.2884629,14.2931716 Z M16,8 L16,4 L14,4 L14,9.00922203 C14,9.28130552 14.1097429,9.52777327 14.2884629,9.70682845 C14.4759332,9.88931059 14.7223751,10 14.990778,10 L20,10 L20,8 L16,8 Z M8,16 L8,20 L10,20 L10,14.990778 C10,14.7186945 9.89025712,14.4722267 9.71153715,14.2931716 C9.52406685,14.1106894 9.27762494,14 9.00922203,14 L4,14 L4,16 L8,16 L8,16 Z M9.71153715,9.70682845 C9.89025712,9.52777327 10,9.28130552 10,9.00922203 L10,4 L8,4 L8,8 L4,8 L4,10 L9.00922203,10 C9.27762494,10 9.52406685,9.88931059 9.70402912,9.71011452 L9.71153715,9.70682845 Z"
}));
var volume = React.createElement("svg", {
  viewBox: "0 0 24 24"
}, React.createElement("path", {
  d: "M5,12.0119396 L5,14.5238791 L8.33098415,14.5238791 L8.33098415,14.5238791 C8.39017333,14.520451 8.4497727,14.5223174 8.50904598,14.5296109 C8.72475585,14.5524598 8.91816198,14.6424266 9.06920843,14.7779841 L13,17.4293365 L13,12.0119396 L13,6.59454265 L9.06920843,9.24589504 C8.91816198,9.38145255 8.72475585,9.47141933 8.50904598,9.49426822 C8.4497727,9.50156175 8.39017333,9.5034281 8.33098415,9.5 L8.33098415,9.5 L5,9.5 L5,12.0119396 Z M3,12.0119396 L3,8.50157356 C3,8.2247344 3.11117675,7.97412842 3.29196292,7.79283868 C3.46994918,7.61192872 3.71994909,7.5 4.00000001,7.5 L8.08102098,7.5 L13.3535806,3.94361361 C13.5372091,3.81975463 13.7472793,3.76538554 13.9529683,3.77494994 C13.9685502,3.77423867 13.98423,3.77387913 14,3.77387913 C14.5522847,3.77387913 15,4.21934183 15,4.77259008 L15,12.0119396 L15,19.251289 C15,19.8045373 14.5522847,20.25 14,20.25 C13.98423,20.25 13.9685502,20.2496405 13.9529683,20.2489292 C13.7472793,20.2584936 13.5372091,20.2041245 13.3535806,20.0802655 L8.08102098,16.5238791 L4.00000001,16.5238791 C3.71994909,16.5238791 3.46994918,16.4119504 3.29196292,16.2310404 C3.11117675,16.0497507 3,15.7991447 3,15.5223056 L3,12.0119396 Z M17.5059844,15.7803571 L17.5,15.7726628 C18.6746368,14.8577452 19.4301566,13.4299638 19.4301566,11.8257212 C19.4301566,10.2214787 18.6746368,8.79369726 17.5,7.87877967 L17.5067574,7.87009164 C17.2041341,7.69816923 17,7.37292366 17,7 C17,6.44771525 17.4477153,6 18,6 C18.2836948,6 18.5397977,6.11813499 18.721799,6.30789526 L18.7279374,6.30000305 C20.3724289,7.58088767 21.4301566,9.57978168 21.4301566,11.8257212 C21.4301566,14.0716608 20.3724289,16.0705548 18.7279374,17.3514394 L18.7211832,17.3427554 C18.5392202,17.5321404 18.283375,17.6500092 18,17.6500092 C17.4477153,17.6500092 17,17.2022939 17,16.6500092 C17,16.2774031 17.2037866,15.9523939 17.5059844,15.7803571 L17.5059844,15.7803571 Z"
}));

var PlayButtonItem = function PlayButtonItem(_ref15) {
  var isPlaying = _ref15.isPlaying,
      onClick = _ref15.onClick;
  return React.createElement("div", {
    className: css(styles$4.toggle)
  }, React.createElement("button", {
    className: css(styles$4.button),
    onClick: onClick
  }, React.createElement(Icon, {
    icon: isPlaying ? pause$1 : play$1
  })));
};

function calculatePercentage(value, total) {
  if (!total) {
    return "0%";
  }

  return "".concat(clamp(value / total, 0, 1) * 100, "%");
}

var styles$5 = StyleSheet.create({
  root: {
    overflow: 'hidden',
    userSelect: 'none',
    cursor: 'pointer',
    touchAction: 'none',
    WebkitTapHighlightColor: 'transparent',
    ':focus': {
      outline: 'none'
    }
  },
  inner: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    height: '100%'
  },
  track: {
    position: 'relative',
    flex: 1,
    overflow: 'hidden',
    backgroundColor: 'rgba(255, 255, 255, 0.3)',
    borderRadius: '2px'
  },
  bar: {
    position: 'absolute',
    backgroundColor: '#fff',
    borderRadius: '2px 0 0 2px'
  },
  thumbWrapper: {
    position: 'absolute'
  },
  thumb: {
    width: '1em',
    height: '1em',
    margin: '-0.5em',
    borderRadius: '50%',
    backgroundColor: '#fff'
  }
});
var horizontal = StyleSheet.create({
  root: {
    height: '1em',
    padding: "0 0.5em"
  },
  inner: {
    flexDirection: 'row'
  },
  track: {
    height: 4
  },
  bar: {
    top: 0,
    bottom: 0
  },
  thumbWrapper: {
    top: '50%'
  }
});
var vertical = StyleSheet.create({
  root: {
    width: '1em',
    padding: "0.5em 0"
  },
  inner: {
    flexDirection: 'column'
  },
  track: {
    width: 4
  },
  bar: {
    left: 0,
    right: 0
  },
  thumbWrapper: {
    left: '50%'
  }
});

var Slider =
/*#__PURE__*/
function (_Component3) {
  _inherits(Slider, _Component3);

  function Slider() {
    var _getPrototypeOf6;

    var _this10;

    _classCallCheck(this, Slider);

    for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      args[_key5] = arguments[_key5];
    }

    _this10 = _possibleConstructorReturn(this, (_getPrototypeOf6 = _getPrototypeOf(Slider)).call.apply(_getPrototypeOf6, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this10), "state", {
      isSlideActive: false,
      isSliding: false,
      slidingValue: null // refs

    });

    _defineProperty(_assertThisInitialized(_this10), "trackRef", React.createRef());

    _defineProperty(_assertThisInitialized(_this10), "handleKeyDown", function (event) {
      var _this10$props = _this10.props,
          reverse = _this10$props.reverse,
          value = _this10$props.value,
          total = _this10$props.total,
          step = _this10$props.step;
      var direction = 0;

      if (event.keyCode === KeyCode.LEFT || event.keyCode === KeyCode.DOWN) {
        direction = -1;
      }

      if (event.keyCode === KeyCode.RIGHT || event.keyCode === KeyCode.UP) {
        direction = 1;
      }

      if (reverse) {
        direction = -direction;
      }

      var result = clamp(value + step * direction, 0, total);

      if (result !== value) {
        event.preventDefault();

        _this10.handleChange(result);
      }
    });

    _defineProperty(_assertThisInitialized(_this10), "handleDragStart", function (event) {
      if (event.button !== 0) return;

      var value = _this10.getSlidingValue(event);

      _this10.setState({
        isSlideActive: true,
        slidingValue: value
      });

      var onDragStart = _this10.props.onDragStart;

      if (onDragStart) {
        onDragStart();
      }

      _this10.handleChange(value);

      _this10.registerEvents();
    });

    _defineProperty(_assertThisInitialized(_this10), "handleDragMove", function (event) {
      var value = _this10.getSlidingValue(event);

      _this10.setState({
        slidingValue: value,
        isSliding: true
      });

      _this10.handleChange(value);
    });

    _defineProperty(_assertThisInitialized(_this10), "handleDragEnd", function (event) {
      _this10.unregisterEvents();

      var onDragEnd = _this10.props.onDragEnd;

      if (onDragEnd) {
        onDragEnd();
      }

      if (_this10.state.isSliding) {
        // 点击动作不需要重复触发 change event
        _this10.handleChange(_this10.getSlidingValue(event));
      }

      _this10.setState({
        isSlideActive: false,
        slidingValue: null,
        isSliding: false
      });
    });

    _defineProperty(_assertThisInitialized(_this10), "handleChange", function (value) {
      var onChange = _this10.props.onChange;

      if (onChange) {
        onChange(value);
      }
    });

    return _this10;
  }

  _createClass(Slider, [{
    key: "registerEvents",
    value: function registerEvents() {
      document.addEventListener('mousemove', this.handleDragMove);
      document.addEventListener('mouseup', this.handleDragEnd);
    }
  }, {
    key: "unregisterEvents",
    value: function unregisterEvents() {
      document.removeEventListener('mousemove', this.handleDragMove);
      document.removeEventListener('mouseup', this.handleDragEnd);
    }
  }, {
    key: "getVariantStyleSheet",
    value: function getVariantStyleSheet() {
      var orientation = this.props.orientation;
      return orientation === 'horizontal' ? horizontal : vertical;
    }
  }, {
    key: "getStyles",
    value: function getStyles(name) {
      var customStyles = this.props.styles;

      if (!Array.isArray(customStyles)) {
        customStyles = [customStyles];
      }

      customStyles = customStyles.filter(Boolean);
      return [styles$5[name], this.getVariantStyleSheet()[name]].concat(_toConsumableArray(customStyles.map(function (item) {
        return item[name];
      })));
    }
  }, {
    key: "getClassName",
    value: function getClassName() {
      var _this11 = this;

      for (var _len6 = arguments.length, names = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        names[_key6] = arguments[_key6];
      }

      return css.apply(void 0, _toConsumableArray(Array.prototype.concat.apply([], names.map(function (name) {
        return _this11.getStyles(name);
      }))));
    }
  }, {
    key: "getAlignKey",
    value: function getAlignKey() {
      var _this$props3 = this.props,
          orientation = _this$props3.orientation,
          reverse = _this$props3.reverse;

      if (orientation === 'horizontal') {
        return reverse ? 'right' : 'left';
      } else {
        return reverse ? 'top' : 'bottom';
      }
    }
  }, {
    key: "getSizeKey",
    value: function getSizeKey() {
      var orientation = this.props.orientation;
      return orientation === 'horizontal' ? 'width' : 'height';
    }
  }, {
    key: "getPercentage",
    value: function getPercentage() {
      var _this$props4 = this.props,
          value = _this$props4.value,
          total = _this$props4.total;
      var _this$state5 = this.state,
          isSlideActive = _this$state5.isSlideActive,
          slidingValue = _this$state5.slidingValue;
      return calculatePercentage(isSlideActive ? slidingValue : value, total);
    }
  }, {
    key: "getBufferedPercentage",
    value: function getBufferedPercentage() {
      var _this$props5 = this.props,
          buffered = _this$props5.buffered,
          total = _this$props5.total;
      return calculatePercentage(buffered, total);
    }
  }, {
    key: "getSlidingValue",
    value: function getSlidingValue(event) {
      var _this$props6 = this.props,
          orientation = _this$props6.orientation,
          reverse = _this$props6.reverse,
          total = _this$props6.total;
      var track = this.trackRef.current;
      if (!track) return 0;
      var rect = track.getBoundingClientRect();
      var value;

      if (orientation === 'horizontal') {
        value = (event.clientX - rect.left) / rect.width;
      } else {
        value = (rect.bottom - event.clientY) / rect.height;
      }

      value = clamp(value, 0, 1);

      if (reverse) {
        value = 1 - value;
      }

      return value * total;
    }
  }, {
    key: "render",
    value: function render() {
      var _style, _style2;

      var _this$props7 = this.props,
          buffered = _this$props7.buffered,
          onFocus = _this$props7.onFocus,
          onBlur = _this$props7.onBlur,
          noInteraction = _this$props7.noInteraction;
      var isSlideActive = this.state.isSlideActive;
      var interactionProps = noInteraction ? {} : {
        tabIndex: 0,
        onFocus: onFocus,
        onBlur: onBlur,
        onKeyDown: this.handleKeyDown,
        onMouseDown: this.handleDragStart
      };
      return React.createElement("div", _extends({
        className: this.getClassName('root')
      }, interactionProps), React.createElement("div", {
        className: this.getClassName('inner')
      }, React.createElement("div", {
        ref: this.trackRef,
        className: this.getClassName('track')
      }, Boolean(buffered) && React.createElement("div", {
        className: this.getClassName('bar', 'buffered'),
        style: (_style = {}, _defineProperty2(_style, this.getAlignKey(), 0), _defineProperty2(_style, this.getSizeKey(), this.getBufferedPercentage()), _style)
      }), React.createElement("div", {
        className: this.getClassName('bar'),
        style: (_style2 = {}, _defineProperty2(_style2, this.getAlignKey(), 0), _defineProperty2(_style2, this.getSizeKey(), this.getPercentage()), _style2)
      })), !noInteraction && React.createElement("div", {
        className: this.getClassName('thumbWrapper'),
        style: _defineProperty2({}, this.getAlignKey(), this.getPercentage())
      }, React.createElement("div", {
        className: this.getClassName('thumb', isSlideActive && 'thumbSliding')
      }))));
    }
  }]);

  return Slider;
}(Component);

_defineProperty(Slider, "propTypes", {
  orientation: PropTypes.oneOf(['horizontal', 'vertical']),
  reverse: PropTypes.bool,
  value: PropTypes.number,
  buffered: PropTypes.number,
  total: PropTypes.number,
  step: PropTypes.number,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  onDragStart: PropTypes.func,
  onDragEnd: PropTypes.func,
  onChange: PropTypes.func,
  noInteraction: PropTypes.bool // 不可交互

});

_defineProperty(Slider, "defaultProps", {
  orientation: 'horizontal',
  reverse: false,
  value: 0,
  buffered: 0,
  total: 0,
  step: 1
});

var styles$6 = StyleSheet.create({});
var slider = StyleSheet.create({
  root: {
    height: 40
  },
  track: {
    transition: 'transform 300ms'
  },
  bar: {
    backgroundColor: '#0f88eb'
  },
  thumb: {
    transform: 'scale(0)',
    transition: 'transform 300ms'
  },
  buffered: {
    backgroundColor: 'rgba(255, 255, 255, 0.6)',
    borderRadius: '2px 0 0 2px'
  }
});
var hoveredSlider = StyleSheet.create({
  thumb: {
    transform: 'scale(1)'
  }
});
var minimal = StyleSheet.create({
  root: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    padding: 0,
    height: '3px'
  },
  track: {
    borderRadius: 0
  },
  thumb: {
    display: 'none'
  },
  buffered: {
    backgroundColor: 'rgba(255, 255, 255, 0.3)',
    borderRadius: '2px 0 0 2px'
  }
});

var Timeline =
/*#__PURE__*/
function (_Component4) {
  _inherits(Timeline, _Component4);

  function Timeline() {
    var _getPrototypeOf7;

    var _this12;

    _classCallCheck(this, Timeline);

    for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
      args[_key7] = arguments[_key7];
    }

    _this12 = _possibleConstructorReturn(this, (_getPrototypeOf7 = _getPrototypeOf(Timeline)).call.apply(_getPrototypeOf7, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this12), "state", {
      isHovered: false,
      isFocused: false,
      isDragging: false // refs

    });

    _defineProperty(_assertThisInitialized(_this12), "root", null);

    _defineProperty(_assertThisInitialized(_this12), "handlePointerEnter", function () {
      _this12.setState({
        isHovered: true
      });
    });

    _defineProperty(_assertThisInitialized(_this12), "handlePointerLeave", function () {
      _this12.setState({
        isHovered: false,
        isFocused: false
      });
    });

    _defineProperty(_assertThisInitialized(_this12), "handleFocus", function () {
      _this12.setState({
        isFocused: true
      });
    });

    _defineProperty(_assertThisInitialized(_this12), "handleBlur", function () {
      _this12.setState({
        isFocused: false
      });
    });

    _defineProperty(_assertThisInitialized(_this12), "handleDragStart", function () {
      _this12.setState({
        isDragging: true
      });

      var onDragStart = _this12.props.onDragStart;

      if (onDragStart) {
        onDragStart();
      }
    });

    _defineProperty(_assertThisInitialized(_this12), "handleDragEnd", function () {
      _this12.setState({
        isDragging: false
      });

      var onDragEnd = _this12.props.onDragEnd;

      if (onDragEnd) {
        onDragEnd();
      }
    });

    _defineProperty(_assertThisInitialized(_this12), "handleChange", function (value) {
      var _this12$props = _this12.props,
          onSeek = _this12$props.onSeek,
          onChange = _this12$props.onChange;

      if (onSeek && value !== _this12.props.value) {
        onChange(value);
      }

      if (_this12.state.isDragging) return;

      if (onSeek) {
        onSeek(value);
      }
    });

    return _this12;
  }

  _createClass(Timeline, [{
    key: "render",
    value: function render() {
      var _this$state6 = this.state,
          isHovered = _this$state6.isHovered,
          isFocused = _this$state6.isFocused,
          isDragging = _this$state6.isDragging;
      return React.createElement("div", {
        className: css(styles$6.root),
        onMouseEnter: this.handlePointerEnter,
        onMouseLeave: this.handlePointerLeave
      }, React.createElement(Slider, _extends({}, this.props, {
        styles: [slider, (isHovered || isFocused || isDragging) && hoveredSlider],
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        onDragStart: this.handleDragStart,
        onDragEnd: this.handleDragEnd,
        onChange: this.handleChange
      })));
    }
  }]);

  return Timeline;
}(Component);

_defineProperty(Timeline, "propTypes", {
  onDragStart: PropTypes.func,
  onDragEnd: PropTypes.func,
  onChange: PropTypes.func,
  onSeek: PropTypes.func
});

var MinimalTimeline =
/*#__PURE__*/
function (_Component5) {
  _inherits(MinimalTimeline, _Component5);

  function MinimalTimeline() {
    _classCallCheck(this, MinimalTimeline);

    return _possibleConstructorReturn(this, _getPrototypeOf(MinimalTimeline).apply(this, arguments));
  }

  _createClass(MinimalTimeline, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      return this.props.show || nextProps.show;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props8 = this.props,
          duration = _this$props8.duration,
          currentTime = _this$props8.currentTime,
          buffered = _this$props8.buffered;
      return React.createElement(Slider, {
        value: currentTime,
        total: duration,
        buffered: buffered,
        styles: [slider, minimal],
        noInteraction: true
      });
    }
  }]);

  return MinimalTimeline;
}(Component);

_defineProperty(MinimalTimeline, "propTypes", {
  duration: PropTypes.number.isRequired,
  currentTime: PropTypes.number.isRequired,
  buffered: PropTypes.number.isRequired,
  show: PropTypes.bool
});

_defineProperty(MinimalTimeline, "defaultProps", {
  duration: 0,
  currentTime: 0,
  buffered: 0
});

var TimelineItem = function TimelineItem(props) {
  return React.createElement("div", {
    className: css(styles$4.timeline)
  }, React.createElement(Timeline, props));
};

var CombinedTimeItem = function CombinedTimeItem(_ref16) {
  var isFullScreen = _ref16.isFullScreen,
      currentTime = _ref16.currentTime,
      duration = _ref16.duration;
  return React.createElement("div", {
    className: css(styles$4.time, isFullScreen && styles$4.fullScreenedTime)
  }, React.createElement("div", {
    className: css(styles$4.timeText)
  }, React.createElement(Time, {
    value: currentTime
  }), ' / ', React.createElement(Time, {
    value: duration
  })));
};
/**
 * reverse an array without mutating the original one
 */


var reverseArray = function reverseArray(arr) {
  return arr.slice().reverse();
};

var LocaleContext = React.createContext('en');
LocaleContext.displayName = 'LocaleContext';
var strings = {
  en: {
    'quality-auto': 'Auto',
    'quality-ld': 'LD',
    'quality-sd': 'SD',
    'quality-hd': 'HD',
    'action-enter-fullscreen': 'Fullscreen',
    'action-exit-fullscreen': 'Exit Fullscreen'
  },
  ja: {
    'quality-auto': '自動',
    'quality-ld': '低画質',
    'quality-sd': '標準画質',
    'quality-hd': '高画質',
    'action-enter-fullscreen': '全画面',
    'action-exit-fullscreen': '全画面終了'
  },
  // covers zh-Hans-CN and zh-Hans-SG
  'zh-Hans': {
    'quality-auto': '自动',
    'quality-ld': '低清',
    'quality-sd': '标清',
    'quality-hd': '超清',
    'action-enter-fullscreen': '全屏',
    'action-exit-fullscreen': '退出全屏'
  },
  // covers zh-Hant-HK and zh-Hant-TW
  'zh-Hant': {
    'quality-auto': '自動',
    'quality-ld': '低畫質',
    'quality-sd': '標準畫質',
    'quality-hd': '高畫質',
    'action-enter-fullscreen': '全螢幕',
    'action-exit-fullscreen': '結束全螢幕'
  }
};

var TranslatedText = function TranslatedText(_ref17) {
  var name = _ref17.name;
  return React.createElement(LocaleContext.Consumer, null, function (locale) {
    return strings[locale][name];
  });
};

var QUALITIES = {
  auto: 'quality-auto',
  ld: 'quality-ld',
  sd: 'quality-sd',
  hd: 'quality-hd'
};

var QualityMenuItem =
/*#__PURE__*/
function (_React$PureComponent3) {
  _inherits(QualityMenuItem, _React$PureComponent3);

  function QualityMenuItem() {
    var _getPrototypeOf8;

    var _this13;

    _classCallCheck(this, QualityMenuItem);

    for (var _len8 = arguments.length, args = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
      args[_key8] = arguments[_key8];
    }

    _this13 = _possibleConstructorReturn(this, (_getPrototypeOf8 = _getPrototypeOf(QualityMenuItem)).call.apply(_getPrototypeOf8, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this13), "state", {
      isQualityHovered: false
    });

    _defineProperty(_assertThisInitialized(_this13), "handleQualityPointerEnter", function () {
      _this13.setState({
        isQualityHovered: true
      });
    });

    _defineProperty(_assertThisInitialized(_this13), "handleQualityPointerLeave", function () {
      _this13.setState({
        isQualityHovered: false
      });
    });

    return _this13;
  }

  _createClass(QualityMenuItem, [{
    key: "render",
    value: function render() {
      var _this14 = this;

      var isQualityHovered = this.state.isQualityHovered;
      return React.createElement(VideoSourceContext.Consumer, null, function (_ref18) {
        var qualities = _ref18.qualities,
            setCurrentQuality = _ref18.setCurrentQuality,
            currentQuality = _ref18.currentQuality;
        return qualities.length > 1 && React.createElement("div", {
          className: css(styles$4.menuContainer),
          onMouseEnter: _this14.handleQualityPointerEnter,
          onMouseLeave: _this14.handleQualityPointerLeave
        }, React.createElement("button", {
          className: css(styles$4.button, styles$4.qualityButton)
        }, React.createElement("span", {
          className: css(styles$4.qualityButtonText)
        }, React.createElement(TranslatedText, {
          name: QUALITIES[currentQuality]
        }))), React.createElement("div", {
          className: css(styles$4.menu, isQualityHovered && styles$4.menuShown)
        }, React.createElement("div", {
          className: css(styles$4.qualityMenu)
        }, reverseArray(qualities).map(function (q) {
          return React.createElement("button", {
            key: q,
            className: css(styles$4.qualityMenuItem, currentQuality === q && styles$4.qualityMenuActiveItem),
            onClick: function onClick() {
              return setCurrentQuality(q);
            }
          }, React.createElement(TranslatedText, {
            name: QUALITIES[q]
          }));
        }))));
      });
    }
  }]);

  return QualityMenuItem;
}(React.PureComponent);

var styles$7 = StyleSheet.create({
  root: {
    padding: '0.375em 0'
  }
});
var slider$1 = StyleSheet.create({
  root: {
    width: '2.5em',
    height: '4em'
  },
  track: {
    margin: '-0.4em 0',
    // 之前是 -0.5em（thumb 的半径），是为了在 0 或 100% 的情况下，让 thumb 的边缘和 track 的边缘平齐
    // 因为下面缩放了 0.8 所以改为 0.5em * 0.8 = 0.4em
    // workaround for bug with overflow: hidden; in chrome
    transform: 'translate3d(0, 0, 0)'
  },
  thumb: {
    transform: 'scale(0.8)',
    transition: 'transform 300ms',
    ':hover': {
      transform: 'scale(1)'
    }
  },
  thumbSliding: {
    transform: 'scale(1)'
  }
});

var VolumeSlider =
/*#__PURE__*/
function (_Component6) {
  _inherits(VolumeSlider, _Component6);

  function VolumeSlider() {
    _classCallCheck(this, VolumeSlider);

    return _possibleConstructorReturn(this, _getPrototypeOf(VolumeSlider).apply(this, arguments));
  }

  _createClass(VolumeSlider, [{
    key: "render",
    value: function render() {
      return React.createElement("div", {
        className: css(styles$7.root)
      }, React.createElement(Slider, _extends({}, this.props, {
        styles: slider$1,
        orientation: "vertical",
        step: 0.1
      })));
    }
  }]);

  return VolumeSlider;
}(Component);

var VolumeItem = function VolumeItem(_ref19) {
  var volume$1 = _ref19.volume,
      menuShown = _ref19.menuShown,
      onMouseEnter = _ref19.onMouseEnter,
      onMouseLeave = _ref19.onMouseLeave,
      onDragStart = _ref19.onDragStart,
      onDragEnd = _ref19.onDragEnd,
      onChange = _ref19.onChange,
      onToggleMuted = _ref19.onToggleMuted;
  return React.createElement("div", {
    className: css(styles$4.menuContainer),
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave
  }, React.createElement("button", {
    className: css(styles$4.button),
    onClick: onToggleMuted
  }, React.createElement(Icon, {
    icon: volume$1 === 0 ? muted : volume
  })), React.createElement("div", {
    className: css(styles$4.menu, menuShown && styles$4.menuShown)
  }, React.createElement(VolumeSlider, {
    value: volume$1,
    total: 1,
    onDragStart: onDragStart,
    onDragEnd: onDragEnd,
    onChange: onChange
  })));
};

var styles$8 = StyleSheet.create({
  root: {
    padding: '0.25em 0.5em',
    fontSize: '0.875em',
    whiteSpace: 'nowrap',
    color: '#fff'
  }
});

var Tooltip =
/*#__PURE__*/
function (_Component7) {
  _inherits(Tooltip, _Component7);

  function Tooltip() {
    _classCallCheck(this, Tooltip);

    return _possibleConstructorReturn(this, _getPrototypeOf(Tooltip).apply(this, arguments));
  }

  _createClass(Tooltip, [{
    key: "render",
    value: function render() {
      var content = this.props.content;
      return React.createElement("div", {
        className: css(styles$8.root)
      }, React.createElement(TranslatedText, {
        name: content
      }));
    }
  }]);

  return Tooltip;
}(Component);

_defineProperty(Tooltip, "propTypes", {
  content: PropTypes.string.isRequired
});

var Hover =
/*#__PURE__*/
function (_React$Component4) {
  _inherits(Hover, _React$Component4);

  function Hover() {
    var _getPrototypeOf9;

    var _this15;

    _classCallCheck(this, Hover);

    for (var _len9 = arguments.length, args = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
      args[_key9] = arguments[_key9];
    }

    _this15 = _possibleConstructorReturn(this, (_getPrototypeOf9 = _getPrototypeOf(Hover)).call.apply(_getPrototypeOf9, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this15), "state", {
      isHovered: false
    });

    _defineProperty(_assertThisInitialized(_this15), "handlePointerEnter", function () {
      _this15.setState({
        isHovered: true
      });
    });

    _defineProperty(_assertThisInitialized(_this15), "handlePointerLeave", function () {
      _this15.setState({
        isHovered: false
      });
    });

    return _this15;
  }

  _createClass(Hover, [{
    key: "render",
    value: function render() {
      var _this$props9 = this.props,
          onMouseEnter = _this$props9.onMouseEnter,
          onMouseLeave = _this$props9.onMouseLeave,
          children = _this$props9.children,
          rest = _objectWithoutProperties(_this$props9, ["onMouseEnter", "onMouseLeave", "children"]);

      var isHovered = this.state.isHovered;
      return React.createElement("div", _extends({}, rest, {
        onMouseEnter: sequence(this.handlePointerEnter, onMouseEnter || noop),
        onMouseLeave: sequence(this.handlePointerLeave, onMouseLeave || noop)
      }), children(isHovered));
    }
  }]);

  return Hover;
}(React.Component);

var FullScreenButtonItem = function FullScreenButtonItem(_ref20) {
  var isFullScreen = _ref20.isFullScreen,
      onClick = _ref20.onClick;
  return React.createElement(Hover, {
    className: css(styles$4.menuContainer)
  }, function (isFullScreenHovered) {
    return React.createElement(React.Fragment, null, React.createElement("button", {
      className: css(styles$4.button),
      onClick: onClick
    }, React.createElement(Icon, {
      icon: isFullScreen ? smallscreen : fullscreen
    })), React.createElement("div", {
      className: css(styles$4.fullScreenTooltip, styles$4.menu, isFullScreenHovered && styles$4.menuShown, isFullScreen && styles$4.fullScreenTooltipWide)
    }, React.createElement(Tooltip, {
      content: isFullScreen ? 'action-exit-fullscreen' : 'action-enter-fullscreen'
    })));
  });
};

var Controller =
/*#__PURE__*/
function (_Component8) {
  _inherits(Controller, _Component8);

  function Controller() {
    var _getPrototypeOf10;

    var _this16;

    _classCallCheck(this, Controller);

    for (var _len10 = arguments.length, args = new Array(_len10), _key10 = 0; _key10 < _len10; _key10++) {
      args[_key10] = arguments[_key10];
    }

    _this16 = _possibleConstructorReturn(this, (_getPrototypeOf10 = _getPrototypeOf(Controller)).call.apply(_getPrototypeOf10, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this16), "state", {
      isVolumeHovered: false,
      isVolumeDragging: false,
      isVolumeKeyboard: false
    });

    _defineProperty(_assertThisInitialized(_this16), "prevVolume", 1);

    _defineProperty(_assertThisInitialized(_this16), "firstKey", true);

    _defineProperty(_assertThisInitialized(_this16), "slideTime", null);

    _defineProperty(_assertThisInitialized(_this16), "onDragMove", function (slideTime) {
      var duration = _this16.props.duration;
      slideTime = clamp(slideTime, 0, duration);

      _this16.setState({
        slideTime: slideTime
      });
    });

    _defineProperty(_assertThisInitialized(_this16), "handleToggle", function (type) {
      var _this16$props = _this16.props,
          isPlaying = _this16$props.isPlaying,
          onPlay = _this16$props.onPlay,
          onPause = _this16$props.onPause;

      if (!isPlaying && onPlay) {
        onPlay(type);
      }

      if (isPlaying && onPause) {
        onPause(type);
      }
    });

    _defineProperty(_assertThisInitialized(_this16), "handleSeek", function (currentTime) {
      var _this16$props2 = _this16.props,
          duration = _this16$props2.duration,
          onSeek = _this16$props2.onSeek;
      currentTime = clamp(currentTime, 0, duration);

      if (onSeek) {
        onSeek(currentTime);

        _this16.setState({
          slideTime: null
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this16), "handleVolumeChange", function (volume) {
      volume = clamp(volume, 0, 1);
      var onVolumeChange = _this16.props.onVolumeChange;

      if (onVolumeChange) {
        onVolumeChange(volume);
      }
    });

    _defineProperty(_assertThisInitialized(_this16), "handleToggleMuted", function () {
      var volume = _this16.props.volume;

      if (volume) {
        _this16.prevVolume = volume;
      }

      _this16.handleVolumeChange(volume ? 0 : _this16.prevVolume);
    });

    _defineProperty(_assertThisInitialized(_this16), "handleVolumePointerEnter", function () {
      _this16.setState({
        isVolumeHovered: true
      });
    });

    _defineProperty(_assertThisInitialized(_this16), "handleVolumePointerLeave", function () {
      _this16.setState({
        isVolumeHovered: false
      });
    });

    _defineProperty(_assertThisInitialized(_this16), "handleVolumeDragStart", function () {
      var volume = _this16.props.volume;

      if (volume) {
        _this16.prevVolume = volume;
      }

      _this16.setState({
        isVolumeDragging: true
      });

      var onDragStart = _this16.props.onDragStart;

      if (onDragStart) {
        onDragStart();
      }
    });

    _defineProperty(_assertThisInitialized(_this16), "handleVolumeDragEnd", function () {
      _this16.setState({
        isVolumeDragging: false
      });

      var onDragEnd = _this16.props.onDragEnd;

      if (onDragEnd) {
        onDragEnd();
      }
    });

    _defineProperty(_assertThisInitialized(_this16), "handleKeyDown", function (event) {
      var _this16$props3 = _this16.props,
          duration = _this16$props3.duration,
          currentTime = _this16$props3.currentTime,
          volume = _this16$props3.volume,
          show = _this16$props3.show,
          onToggleFullScreen = _this16$props3.onToggleFullScreen;
      var handled = true;

      switch (event.keyCode) {
        case KeyCode.SPACE:
        case KeyCode.K:
          if (_this16.firstKey) {
            _this16.handleToggle('keyCode');
          }

          break;

        case KeyCode.ENTER:
        case KeyCode.F:
          if (_this16.firstKey) {
            onToggleFullScreen();
          }

          break;

        case KeyCode.LEFT:
          _this16.handleSeek(currentTime - 5);

          break;

        case KeyCode.RIGHT:
          _this16.handleSeek(currentTime + 5);

          break;

        case KeyCode.J:
          if (_this16.firstKey) {
            _this16.handleSeek(currentTime - 10);
          }

          break;

        case KeyCode.L:
          if (_this16.firstKey) {
            _this16.handleSeek(currentTime + 10);
          }

          break;

        case KeyCode.ZERO:
        case KeyCode.ONE:
        case KeyCode.TWO:
        case KeyCode.THREE:
        case KeyCode.FOUR:
        case KeyCode.FIVE:
        case KeyCode.SIX:
        case KeyCode.SEVEN:
        case KeyCode.EIGHT:
        case KeyCode.NINE:
          if (show && _this16.firstKey) {
            var nextTime = duration / 10 * (event.keyCode - KeyCode.ZERO);

            _this16.handleSeek(nextTime);
          }

          break;

        case KeyCode.M:
          if (_this16.firstKey) {
            _this16.handleToggleMuted();
          }

          break;

        case KeyCode.UP:
          if (_this16.firstKey && volume) {
            _this16.prevVolume = volume;
          }

          _this16.setState({
            isVolumeKeyboard: true
          });

          _this16.handleVolumeChange(volume + 0.05);

          break;

        case KeyCode.DOWN:
          if (_this16.firstKey && volume) {
            _this16.prevVolume = volume;
          }

          _this16.handleVolumeChange(volume - 0.05);

          break;

        default:
          handled = false;
          break;
      }

      if (handled) {
        event.preventDefault();
      }

      _this16.firstKey = false;
    });

    _defineProperty(_assertThisInitialized(_this16), "handleKeyUp", function (event) {
      _this16.firstKey = true;

      switch (event.keyCode) {
        case KeyCode.UP:
        case KeyCode.DOWN:
          _this16.handleVolumeKeyboard();

          break;
      }
    });

    _defineProperty(_assertThisInitialized(_this16), "handleVolumeKeyboard", debounce(function () {
      _this16.setState({
        isVolumeKeyboard: false
      });
    }, 1000));

    return _this16;
  }

  _createClass(Controller, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.standalone) {
        document.addEventListener('keydown', this.handleKeyDown);
        document.addEventListener('keyup', this.handleKeyUp);
      }
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      return this.props.show || nextProps.show;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.props.standalone) {
        document.removeEventListener('keydown', this.handleKeyDown);
        document.removeEventListener('keyup', this.handleKeyUp);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this17 = this;

      var _this$props10 = this.props,
          isPlaying = _this$props10.isPlaying,
          buffered = _this$props10.buffered,
          duration = _this$props10.duration,
          currentTime = _this$props10.currentTime,
          volume = _this$props10.volume,
          isFullScreen = _this$props10.isFullScreen,
          onDragStart = _this$props10.onDragStart,
          onDragEnd = _this$props10.onDragEnd,
          onToggleFullScreen = _this$props10.onToggleFullScreen;
      var _this$state7 = this.state,
          isVolumeHovered = _this$state7.isVolumeHovered,
          isVolumeDragging = _this$state7.isVolumeDragging,
          isVolumeKeyboard = _this$state7.isVolumeKeyboard,
          slideTime = _this$state7.slideTime;
      var displayedCurrentTime = slideTime || currentTime;
      return React.createElement("div", {
        className: css(styles$4.root, isFullScreen && styles$4.fullScreened)
      }, React.createElement(PlayButtonItem, {
        isPlaying: isPlaying,
        onClick: function onClick() {
          return _this17.handleToggle('button');
        }
      }), React.createElement(TimelineItem, {
        value: currentTime,
        total: duration,
        buffered: buffered,
        onDragStart: onDragStart,
        onDragEnd: onDragEnd,
        onChange: this.onDragMove,
        onSeek: this.handleSeek
      }), React.createElement(CombinedTimeItem, {
        isFullScreen: isFullScreen,
        currentTime: displayedCurrentTime,
        duration: duration
      }), React.createElement(QualityMenuItem, null), React.createElement(VolumeItem, {
        volume: volume,
        menuShown: isVolumeHovered || isVolumeDragging || isVolumeKeyboard,
        onMouseEnter: this.handleVolumePointerEnter,
        onMouseLeave: this.handleVolumePointerLeave,
        onToggleMuted: this.handleToggleMuted,
        onDragStart: this.handleVolumeDragStart,
        onDragEnd: this.handleVolumeDragEnd,
        onChange: this.handleVolumeChange
      }), React.createElement(FullScreenButtonItem, {
        isFullScreen: isFullScreen,
        onClick: onToggleFullScreen
      }));
    }
  }]);

  return Controller;
}(Component);

_defineProperty(Controller, "propTypes", {
  standalone: PropTypes.bool,
  isPlaying: PropTypes.bool,
  duration: PropTypes.number,
  currentTime: PropTypes.number,
  volume: PropTypes.number,
  buffered: PropTypes.number,
  isFullScreen: PropTypes.bool,
  onDragStart: PropTypes.func,
  onDragEnd: PropTypes.func,
  onPlay: PropTypes.func,
  onPause: PropTypes.func,
  onSeek: PropTypes.func,
  onQualityChange: PropTypes.func,
  onVolumeChange: PropTypes.func,
  onToggleFullScreen: PropTypes.func,
  show: PropTypes.bool
});

_defineProperty(Controller, "defaultProps", {
  standalone: false,
  isPlaying: false,
  duration: 0,
  currentTime: 0,
  volume: 0.5,
  buffered: 0,
  isFullScreen: false
});

function getBufferedTime(currentTime, buffered) {
  var item = buffered.find(function (item) {
    return item.start <= currentTime && currentTime <= item.end;
  });

  if (item) {
    return item.end;
  }

  return 0;
}

var compatibleStorage = {
  store: {},
  setItem: function setItem(key, value) {
    this.store[key] = value;
  },
  removeItem: function removeItem(key) {
    return delete this.store[key];
  },
  getItem: function getItem(key) {
    return this.store[key];
  }
};
var storage = {
  isSupported: memoize(function () {
    try {
      var testSupport = {
        key: '__test_support_key__',
        value: '__test_support_value__'
      };
      var supported = Boolean(global.localStorage);
      localStorage.setItem(testSupport.key, testSupport.value);
      localStorage.removeItem(testSupport.key);
      return supported;
    } catch (err) {
      return false;
    }
  }),
  getStorage: memoize(function () {
    return storage.isSupported() ? localStorage : compatibleStorage;
  }),
  set: function set(key, value) {
    storage.getStorage().setItem(key, JSON.stringify(value));
  },
  get: function get(key) {
    try {
      var value = storage.getStorage().getItem(key);
      return JSON.parse(value);
    } catch (error) {
      return null;
    }
  },
  delete: function _delete(key) {
    storage.getStorage().removeItem(key);
  }
};
var actionAnimation = {
  '0%': {
    opacity: 0,
    transform: 'scale(0)'
  },
  '50%': {
    opacity: 0.6,
    transform: 'scale(0.8)'
  },
  '100%': {
    opacity: 0,
    transform: 'scale(1)'
  }
};
var fadeinAnimation = {
  '0%': {
    opacity: 0
  },
  '100%': {
    opacity: 1
  }
};
var breakpoints = {
  mobile: '26em' // 416px

};

var breakTo = function breakTo(breakpoint) {
  return "@media screen and (max-width: ".concat(breakpoints[breakpoint], ")");
};

var styles$9 = StyleSheet.create({
  root: {
    position: 'relative',
    overflow: 'hidden',
    userSelect: 'none',
    width: '100%',
    height: '100%',
    fontSize: 16,
    backgroundColor: '#000',
    ':focus': {
      outline: 'none'
    }
  },
  fullScreened: {
    fontSize: 24
  },
  actionButton: {
    width: '4.5em',
    height: '4.5em'
  },
  actionButtonAnimated: {
    animationName: actionAnimation,
    animationDuration: '600ms',
    animationFillMode: 'both'
  },
  actionIcon: _defineProperty2({
    width: '4.5em',
    height: '4.5em'
  }, breakTo('mobile'), {
    transform: 'scale(0.75)'
  }),
  video: {
    width: '100%',
    height: '100%'
  },
  overlay: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    overflow: 'hidden'
  },
  overlayMask: {
    background: 'rgba(0, 0, 0, 0.08)'
  },
  loader: {
    position: 'absolute',
    left: '50%',
    top: '50%',
    color: '#0f88eb',
    transform: 'translate(-50%, -50%)'
  },
  action: {
    position: 'absolute',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)'
  },
  backdrop: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0
  },
  title: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    overflow: 'hidden',
    padding: '0 1em',
    lineHeight: 2.5,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    color: '#fff',
    backgroundImage: 'linear-gradient(to top, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.3))',
    transform: 'translateY(-100%)',
    transition: 'transform 300ms'
  },
  titleShown: {
    transform: 'translateY(0)'
  },
  controller: {
    position: 'absolute',
    left: 0,
    right: 0,
    bottom: 0,
    backgroundImage: 'linear-gradient(to bottom, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.3))'
  },
  cover: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    overflow: 'hidden',
    backgroundColor: '#000',
    cursor: 'pointer',
    visibility: 'hidden',
    opacity: 0,
    transition: 'visibility 300ms, opacity 300ms'
  },
  coverShown: {
    visibility: 'visible',
    opacity: 1
  },
  coverImage: {
    position: 'absolute',
    left: 0,
    top: 0,
    width: '100%',
    height: '100%'
  },
  coverTime: {
    position: 'absolute',
    right: '0.5em',
    bottom: '0.5em',
    padding: '0.375em',
    fontSize: '0.875em',
    lineHeight: 1,
    color: 'rgba(255, 255, 255, 0.9)',
    backgroundColor: 'transparent',
    textShadow: '0 0 6px rgba(0, 0, 0, 0.4)'
  },
  coverTimeMobile: {
    padding: 0
  },
  coverAction: {
    position: 'absolute',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)'
  },
  coverReplayAction: {
    position: 'absolute',
    left: '0',
    right: '0',
    top: '0',
    bottom: '0',
    backgroundColor: 'rgba(0, 0, 0, 0.16)',
    animationName: fadeinAnimation,
    animationDuration: '600ms',
    animationFillMode: 'both'
  },
  coverReplayButton: {
    position: 'absolute',
    left: '0',
    right: '0',
    top: '0',
    bottom: '0',
    height: '40px',
    width: '116px',
    margin: 'auto',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    borderRadius: '4px',
    color: '#fff',
    fontSize: '16px',
    lineHeight: '24px',
    padding: '8px',
    boxSizing: 'border-box',
    textAlign: 'center',
    transition: 'transform 200ms, opacity 200ms',
    willChange: 'transform'
  },
  coverReplayButtonHovered: {
    transform: 'scale(1.1)'
  },
  coverReplayButtonPressed: {
    opacity: '0.7'
  },
  replayIcon: {
    verticalAlign: 'top',
    marginRight: '4px'
  },
  error: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    color: '#fff',
    backgroundColor: '#000'
  },
  errorIcon: {
    width: '2.5em',
    height: '2.5em',
    margin: '0 auto',
    fill: 'currentColor'
  },
  errorMessage: {
    marginTop: '1em',
    fontSize: '1.25em',
    lineHeight: 1,
    textAlign: 'center'
  }
});
var hiddenOrShownStyle = StyleSheet.create({
  base: {
    transition: "opacity .5s ease-in-out, visibility .5s ease-in-out"
  },
  hidden: {
    opacity: 0,
    visibility: 'hidden'
  },
  shown: {
    opacity: 1,
    visibility: 'visible'
  }
});
var CONTROLLER_HIDE_DELAY = 3000;
var isMobile$2 = ua.isMobile;

var Player =
/*#__PURE__*/
function (_Component9) {
  _inherits(Player, _Component9);

  function Player() {
    var _getPrototypeOf11;

    var _this18;

    _classCallCheck(this, Player);

    for (var _len11 = arguments.length, args = new Array(_len11), _key11 = 0; _key11 < _len11; _key11++) {
      args[_key11] = arguments[_key11];
    }

    _this18 = _possibleConstructorReturn(this, (_getPrototypeOf11 = _getPrototypeOf(Player)).call.apply(_getPrototypeOf11, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this18), "state", {
      isPlaybackStarted: false,
      // 开始播放的时候设置为 true，播放中途暂停仍然为 true，直到播放到最后停止的时候才会变成 false，
      isNeverPlayed: true,
      // 用户第一次播放之后设置为 false，并且之后永远为 false
      lastAction: null,
      isDataLoaded: false,
      isPlaying: false,
      isLoading: false,
      duration: 0,
      currentTime: 0,
      volume: 0.5,
      buffered: [],
      isControllerShown: false,
      isControllerHovered: false,
      isControllerDragging: false,
      type: null,
      hovered: false,
      pressed: false
    });

    _defineProperty(_assertThisInitialized(_this18), "isSeeking", false);

    _defineProperty(_assertThisInitialized(_this18), "showLoaderTimeout", null);

    _defineProperty(_assertThisInitialized(_this18), "hideControllerTimeout", null);

    _defineProperty(_assertThisInitialized(_this18), "playerRef", React.createRef());

    _defineProperty(_assertThisInitialized(_this18), "videoRef", React.createRef());

    _defineProperty(_assertThisInitialized(_this18), "setDocumentTitle", function () {
      var _this18$props = _this18.props,
          title = _this18$props.title,
          standalone = _this18$props.standalone;

      if (standalone && typeof title === 'string' && title !== document.title) {
        document.title = title;
      }
    });

    _defineProperty(_assertThisInitialized(_this18), "handlePauseAction", function () {
      var _ref21 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          dontApplyOnFullScreen = _ref21.dontApplyOnFullScreen;

      if (!_this18.state.isPlaying) return;
      if (dontApplyOnFullScreen && Boolean(BigScreen.element)) return;

      _this18.handlePause('button'); // 通过这种方式暂停不会显示中间的图标

    });

    _defineProperty(_assertThisInitialized(_this18), "handleToggle", function () {
      if (_this18.state.isPlaying) {
        _this18.handlePause('video');
      } else {
        _this18.handlePlay('video');
      }
    });

    _defineProperty(_assertThisInitialized(_this18), "handlePlay", function () {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var _this18$props2 = _this18.props,
          onEvent = _this18$props2.onEvent,
          onBeforePlay = _this18$props2.onBeforePlay;
      onEvent(EVENTS.PLAYER.REQUEST_PLAY);
      onBeforePlay().then(function () {
        if (!_this18.state.isPlaybackStarted) {
          onEvent(EVENTS.PLAYER.PLAY_COUNT);

          _this18.setState({
            isPlaybackStarted: true
          });

          if (!_this18.state.isDataLoaded) {
            _this18.setState({
              isLoading: true
            });
          } // workaround a bug in IE about replaying a video.


          if (_this18.state.currentTime !== 0) {
            _this18.handleSeek(0);
          }
        } else {
          _this18.setState({
            lastAction: 'play'
          });
        }

        _this18.setState({
          isPlaying: true,
          type: type,
          isNeverPlayed: false
        });
      }).catch(function () {
        onEvent(EVENTS.PLAYER.PLAY_REJECTED); // 播放被取消
      });
    });

    _defineProperty(_assertThisInitialized(_this18), "handlePause", function () {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      _this18.props.onEvent(EVENTS.PLAYER.REQUEST_PAUSE);

      var isLoading = _this18.state.isLoading;

      if (!isLoading) {
        _this18.setState({
          lastAction: 'pause',
          isPlaying: false,
          type: type
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this18), "handleVideoPlay", function () {
      if (!_this18.state.isPlaying) {
        _this18.setState({
          isPlaying: true
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this18), "handleVideoPause", function () {
      if (_this18.state.isPlaying) {
        _this18.setState({
          isPlaying: false
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this18), "handleVideoEnded", function () {
      _this18.setState({
        isPlaybackStarted: false,
        lastAction: null,
        isPlaying: false,
        isLoading: false
      });
    });

    _defineProperty(_assertThisInitialized(_this18), "handleVideoLoadedData", function () {
      _this18.setState({
        isDataLoaded: true,
        isLoading: false
      });
    });

    _defineProperty(_assertThisInitialized(_this18), "handleVideoError", function () {
      _this18.setState({
        isPlaying: false,
        isLoading: false
      });
    });

    _defineProperty(_assertThisInitialized(_this18), "handleVideoDurationChange", function (duration) {
      _this18.setState({
        duration: duration
      });
    });

    _defineProperty(_assertThisInitialized(_this18), "handleVideoTimeUpdate", function (currentTime) {
      var isLoading = _this18.state.isLoading;
      if (isLoading || _this18.isSeeking) return;
      if (_this18.isSeeking) return;

      _this18.setState({
        currentTime: currentTime
      });
    });

    _defineProperty(_assertThisInitialized(_this18), "handleVideoVolumeChange", function (volume) {
      volume = Math.round(volume * 100) / 100;

      _this18.setState({
        volume: volume
      });

      storage.set('@griffith/history-volume', volume);
    });

    _defineProperty(_assertThisInitialized(_this18), "handleSeek", function (currentTime) {
      var _this18$state = _this18.state,
          isPlaybackStarted = _this18$state.isPlaybackStarted,
          isNeverPlayed = _this18$state.isNeverPlayed,
          stateCurrentTime = _this18$state.currentTime;
      var isPlayEnded = !isPlaybackStarted && !isNeverPlayed && stateCurrentTime !== 0; // 播放结束，显示「重新播放」状态

      _this18.setState({
        currentTime: currentTime
      }); // TODO 想办法去掉这个实例方法调用


      _this18.videoRef.current.seek(currentTime);

      if (isPlayEnded) {
        _this18.handlePlay();
      }
    });

    _defineProperty(_assertThisInitialized(_this18), "handleVideoWaiting", function () {
      if (_this18.showLoaderTimeout !== null) return;
      _this18.showLoaderTimeout = setTimeout(function () {
        _this18.setState({
          isLoading: true
        });
      }, 1000);
    });

    _defineProperty(_assertThisInitialized(_this18), "handleVideoPlaying", function () {
      if (_this18.showLoaderTimeout !== null) {
        clearTimeout(_this18.showLoaderTimeout);
        _this18.showLoaderTimeout = null;
      }

      _this18.setState({
        isLoading: false
      });
    });

    _defineProperty(_assertThisInitialized(_this18), "handleVideoSeeking", function () {
      _this18.isSeeking = true;
    });

    _defineProperty(_assertThisInitialized(_this18), "handleVideoSeeked", function () {
      _this18.isSeeking = false;
    });

    _defineProperty(_assertThisInitialized(_this18), "handleVideoProgress", function (buffered) {
      _this18.setState({
        buffered: buffered
      });
    });

    _defineProperty(_assertThisInitialized(_this18), "handleToggleFullScreen", function () {
      if (BigScreen.enabled) {
        var onEvent = _this18.props.onEvent;

        var onEnter = function onEnter() {
          return onEvent(EVENTS.PLAYER.ENTER_FULLSCREEN);
        };

        var onExit = function onExit() {
          return onEvent(EVENTS.PLAYER.EXIT_FULLSCREEN);
        };

        BigScreen.toggle(_this18.playerRef.current, onEnter, onExit);
      }
    });

    _defineProperty(_assertThisInitialized(_this18), "handleShowController", function () {
      if (!_this18.state.isControllerShown) {
        _this18.setState({
          isControllerShown: true
        });
      }

      if (_this18.hideControllerTimeout !== null) {
        clearTimeout(_this18.hideControllerTimeout);
      }

      _this18.hideControllerTimeout = setTimeout(function () {
        _this18.hideControllerTimeout = null;

        _this18.setState({
          isControllerShown: false
        });
      }, CONTROLLER_HIDE_DELAY);
    });

    _defineProperty(_assertThisInitialized(_this18), "handleHideController", function () {
      if (_this18.hideControllerTimeout !== null) {
        clearTimeout(_this18.hideControllerTimeout);
        _this18.hideControllerTimeout = null;
      }

      _this18.setState({
        isControllerShown: false
      });
    });

    _defineProperty(_assertThisInitialized(_this18), "handleControllerPointerEnter", function () {
      _this18.setState({
        isControllerHovered: true
      });
    });

    _defineProperty(_assertThisInitialized(_this18), "handleControllerPointerLeave", function () {
      _this18.setState({
        isControllerHovered: false
      });
    });

    _defineProperty(_assertThisInitialized(_this18), "handleControllerDragStart", function () {
      _this18.setState({
        isControllerDragging: true
      });
    });

    _defineProperty(_assertThisInitialized(_this18), "handleControllerDragEnd", function () {
      _this18.setState({
        isControllerDragging: false
      });
    });

    _defineProperty(_assertThisInitialized(_this18), "handleMouseEnter", function () {
      _this18.setState({
        hovered: true
      });

      _this18.handleShowController();
    });

    _defineProperty(_assertThisInitialized(_this18), "handleMouseLeave", function () {
      _this18.setState({
        hovered: false
      });

      _this18.handleHideController();
    });

    _defineProperty(_assertThisInitialized(_this18), "handleMouseDown", function () {
      _this18.setState({
        pressed: true
      });

      _this18.handleShowController();
    });

    _defineProperty(_assertThisInitialized(_this18), "handleMouseUp", function () {
      _this18.setState({
        pressed: false
      });

      _this18.handleShowController();
    });

    _defineProperty(_assertThisInitialized(_this18), "handleMouseMove", function () {
      if (!_this18.state.hovered) {
        _this18.setState({
          hovered: true
        });
      }

      _this18.handleShowController();
    });

    return _this18;
  }

  _createClass(Player, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setDocumentTitle();
      var historyVolume = storage.get('@griffith/history-volume');

      if (historyVolume) {
        this.setState({
          volume: historyVolume
        });
      }

      this.pauseActionSubscription = this.props.subscribeAction(ACTIONS.PLAYER.PAUSE, this.handlePauseAction);
      var autoplay = this.props.autoplay;

      if (autoplay && this.videoRef.current.root) {
        if (!this.videoRef.current.root.muted) {
          // Muted autoplay is always allowed
          this.handleVideoVolumeChange(0);
        }

        this.handlePlay('video');
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.setDocumentTitle();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.pauseActionSubscription.unsubscribe();
    }
  }, {
    key: "render",
    value: function render() {
      var _this19 = this;

      var _this$props11 = this.props,
          error = _this$props11.error,
          title = _this$props11.title,
          cover = _this$props11.cover,
          standalone = _this$props11.standalone,
          onEvent = _this$props11.onEvent,
          useMSE = _this$props11.useMSE;
      var _this$state8 = this.state,
          isPlaybackStarted = _this$state8.isPlaybackStarted,
          lastAction = _this$state8.lastAction,
          isPlaying = _this$state8.isPlaying,
          isLoading = _this$state8.isLoading,
          duration = _this$state8.duration,
          isControllerShown = _this$state8.isControllerShown,
          isControllerHovered = _this$state8.isControllerHovered,
          isControllerDragging = _this$state8.isControllerDragging,
          currentTime = _this$state8.currentTime,
          isNeverPlayed = _this$state8.isNeverPlayed,
          volume = _this$state8.volume,
          buffered = _this$state8.buffered,
          type = _this$state8.type,
          hovered = _this$state8.hovered,
          pressed = _this$state8.pressed;
      var isFullScreen = Boolean(BigScreen.element); // 未播放时不展示 Controller
      // 播放中暂停时展示 Controller
      // 播放中 Controller shown/hovered/dragging 时展示 Controller
      // 播放结束展示 Controller

      var showController = isPlaybackStarted && (!isPlaying || isControllerShown || isControllerHovered || isControllerDragging) || !isPlaybackStarted && currentTime !== 0;
      var bufferedTime = getBufferedTime(currentTime, buffered);
      return React.createElement("div", {
        className: css(styles$9.root, isFullScreen && styles$9.fullScreened),
        onMouseLeave: this.handleMouseLeave,
        onMouseEnter: this.handleMouseEnter,
        onMouseDown: this.handleMouseDown,
        onMouseUp: this.handleMouseUp,
        onMouseMove: this.handleShowController,
        ref: this.playerRef
      }, React.createElement("div", {
        className: css(styles$9.video)
      }, React.createElement(Video$1, {
        ref: this.videoRef,
        controls: isMobile$2 && isPlaybackStarted,
        paused: !isPlaying,
        volume: volume,
        onPlay: this.handleVideoPlay,
        onPause: this.handleVideoPause,
        onEnded: this.handleVideoEnded,
        onLoadedData: this.handleVideoLoadedData,
        onError: this.handleVideoError,
        onDurationChange: this.handleVideoDurationChange,
        onTimeUpdate: this.handleVideoTimeUpdate,
        onWaiting: this.handleVideoWaiting,
        onPlaying: this.handleVideoPlaying,
        onSeeking: this.handleVideoSeeking,
        onSeeked: this.handleVideoSeeked,
        onVolumeChange: this.handleVideoVolumeChange,
        onProgress: this.handleVideoProgress,
        onEvent: onEvent,
        useMSE: useMSE
      })), React.createElement("div", {
        className: css(styles$9.cover, !isPlaybackStarted && styles$9.coverShown),
        onClick: function onClick() {
          return _this19.handlePlay();
        }
      }, cover && React.createElement(ObjectFitContext.Consumer, null, function (_ref22) {
        var objectFit = _ref22.objectFit;
        return React.createElement("img", {
          className: css(styles$9.coverImage),
          src: cover,
          style: {
            objectFit: objectFit
          }
        });
      }), duration && currentTime === 0 && React.createElement("div", {
        className: css(styles$9.coverTime, isMobile$2 && styles$9.coverTimeMobile)
      }, React.createElement(Time, {
        value: duration
      })), isNeverPlayed && React.createElement("div", {
        className: css(styles$9.coverAction)
      }, React.createElement("div", {
        className: css(styles$9.actionButton)
      }, React.createElement(Icon, {
        icon: play,
        styles: styles$9.actionIcon
      }))), !isNeverPlayed && currentTime !== 0 && React.createElement("div", {
        className: css(styles$9.coverReplayAction)
      }, React.createElement("div", {
        className: css(styles$9.coverReplayButton, hovered && styles$9.coverReplayButtonHovered, pressed && styles$9.coverReplayButtonPressed)
      }, React.createElement(Icon, {
        icon: replay,
        styles: styles$9.replayIcon
      }), "\u91CD\u65B0\u64AD\u653E"))), !isMobile$2 && React.createElement("div", {
        className: css(styles$9.overlay, isNeverPlayed && styles$9.overlayMask)
      }, isPlaybackStarted && isLoading && React.createElement("div", {
        className: css(styles$9.loader)
      }, React.createElement(Loader, null)), lastAction && type !== 'button' && React.createElement("div", {
        className: css(styles$9.action),
        key: lastAction
      }, React.createElement("div", {
        className: css(styles$9.actionButton, styles$9.actionButtonAnimated)
      }, React.createElement(Icon, {
        icon: lastAction === 'play' ? play : pause,
        styles: styles$9.actionIcon
      }))), React.createElement("div", {
        className: css(styles$9.backdrop),
        onTouchStart: function onTouchStart(event) {
          // prevent touch to toggle
          event.preventDefault();
        },
        onClick: this.handleToggle
      }), title && isFullScreen && React.createElement("div", {
        className: css(styles$9.title, showController && styles$9.titleShown)
      }, title), isPlaying && (!isLoading || currentTime !== 0) && React.createElement("div", {
        className: css(hiddenOrShownStyle.base, showController ? hiddenOrShownStyle.hidden : hiddenOrShownStyle.shown)
      }, React.createElement(MinimalTimeline, {
        buffered: bufferedTime,
        duration: duration,
        currentTime: currentTime,
        show: !showController
      })), isPlaybackStarted && (!isLoading || currentTime !== 0) && React.createElement("div", {
        className: css(styles$9.controller, hiddenOrShownStyle.base, showController ? hiddenOrShownStyle.shown : hiddenOrShownStyle.hidden),
        onMouseEnter: this.handleControllerPointerEnter,
        onMouseLeave: this.handleControllerPointerLeave
      }, React.createElement(Controller, {
        standalone: standalone,
        isPlaying: isPlaying,
        duration: duration,
        currentTime: currentTime,
        volume: volume,
        buffered: bufferedTime,
        isFullScreen: isFullScreen,
        onDragStart: this.handleControllerDragStart,
        onDragEnd: this.handleControllerDragEnd,
        onPlay: this.handlePlay,
        onPause: this.handlePause,
        onSeek: this.handleSeek,
        onVolumeChange: this.handleVideoVolumeChange,
        onToggleFullScreen: this.handleToggleFullScreen,
        show: showController
      }))), error && React.createElement("div", {
        className: css(styles$9.error)
      }, React.createElement(Icon, {
        icon: alert,
        styles: styles$9.errorIcon
      }), error.message && React.createElement("div", {
        className: css(styles$9.errorMessage)
      }, error.message)));
    }
  }]);

  return Player;
}(Component);

_defineProperty(Player, "propTypes", {
  standalone: PropTypes.bool,
  error: PropTypes.shape({
    message: PropTypes.string
  }),
  title: PropTypes.string,
  cover: PropTypes.string,
  duration: PropTypes.number,
  onEvent: PropTypes.func.isRequired,
  onBeforePlay: PropTypes.func.isRequired
});

_defineProperty(Player, "defaultProps", {
  standalone: false,
  duration: 0,
  autoplay: false
});

_defineProperty(Player, "getDerivedStateFromProps", function (props, state) {
  var duration = props.duration;
  var shouldUpdateDuration = duration && !state.duration;
  var newDurationState = shouldUpdateDuration ? {
    duration: duration
  } : null;
  return _objectSpread({}, newDurationState);
});

var PlayerContainer = function PlayerContainer(_ref23) {
  var standalone = _ref23.standalone,
      id = _ref23.id,
      title = _ref23.title,
      cover = _ref23.cover,
      duration = _ref23.duration,
      sources = _ref23.sources,
      error = _ref23.error,
      _ref23$onBeforePlay = _ref23.onBeforePlay,
      _onBeforePlay = _ref23$onBeforePlay === void 0 ? function () {
    return Promise.resolve();
  } : _ref23$onBeforePlay,
      shouldObserveResize = _ref23.shouldObserveResize,
      children = _ref23.children,
      _ref23$initialObjectF = _ref23.initialObjectFit,
      initialObjectFit = _ref23$initialObjectF === void 0 ? 'contain' : _ref23$initialObjectF,
      useMSE = _ref23.useMSE,
      _ref23$locale = _ref23.locale,
      locale = _ref23$locale === void 0 ? 'en' : _ref23$locale,
      autoplay = _ref23.autoplay;

  return React.createElement(ObjectFitProvider, {
    initialObjectFit: initialObjectFit
  }, React.createElement(PositionProvider, {
    shouldObserveResize: shouldObserveResize
  }, React.createElement(MessageProvider, {
    id: id,
    enableCrossWindow: standalone
  }, React.createElement(InternalContext.Consumer, null, function (_ref24) {
    var emitEvent = _ref24.emitEvent,
        subscribeAction = _ref24.subscribeAction;
    return React.createElement(VideoSourceProvider, {
      onEvent: emitEvent,
      sources: sources,
      id: id
    }, React.createElement(LocaleContext.Provider, {
      value: locale
    }, React.createElement(VideoSourceContext.Consumer, null, function (_ref25) {
      var currentSrc = _ref25.currentSrc;
      return React.createElement(Player, {
        useMSE: useMSE,
        autoplay: autoplay,
        standalone: standalone,
        cover: cover,
        title: title,
        duration: duration,
        error: error,
        onEvent: emitEvent,
        subscribeAction: subscribeAction,
        onBeforePlay: function onBeforePlay() {
          return _onBeforePlay(currentSrc);
        }
      });
    }), children));
  }))));
};

PlayerContainer.propTypes = {
  standalone: PropTypes.bool,
  id: PropTypes.string.isRequired,
  title: PropTypes.string,
  cover: PropTypes.string.isRequired,
  duration: PropTypes.number.isRequired,
  sources: PropTypes.objectOf(PropTypes.shape({
    bitrate: PropTypes.number.isRequired,
    duration: PropTypes.number.isRequired,
    format: PropTypes.string.isRequired,
    height: PropTypes.number.isRequired,
    play_url: PropTypes.string.isRequired,
    size: PropTypes.number.isRequired,
    width: PropTypes.number.isRequired
  })).isRequired,
  error: PropTypes.shape({
    message: PropTypes.string
  }),
  onBeforePlay: PropTypes.func,
  initialObjectFit: PropTypes.oneOf(VALID_FIT),
  useMSE: PropTypes.bool
};
var styles$a = StyleSheet.create({
  container: {
    position: 'absolute',
    pointerEvents: 'none',
    overflow: 'hidden'
  },
  containerFullWidth: {
    width: '100%',
    height: 'auto',
    top: '50%',
    left: 0,
    transform: 'translate(0, -50%)'
  },
  containerFullHeight: {
    width: 'auto',
    height: '100%',
    top: 0,
    left: '50%',
    transform: 'translate(-50%)'
  },
  image: {
    display: 'block',
    visibility: 'hidden'
  },
  imageFullWidth: {
    width: '100%',
    height: 'auto'
  },
  imageFullHeight: {
    width: 'auto',
    height: '100%'
  },
  layer: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    overflow: 'hidden',
    pointerEvents: 'none'
  }
});

var getContainerClassName = function getContainerClassName(isFullWidth) {
  return css(styles$a.container, isFullWidth ? styles$a.containerFullWidth : styles$a.containerFullHeight);
};

var getImageClassName = function getImageClassName(isFullWidth) {
  return css(styles$a.image, isFullWidth ? styles$a.imageFullWidth : styles$a.imageFullHeight);
};

var Positioned = function Positioned(_ref26) {
  var children = _ref26.children;
  return React.createElement(PositionContext.Consumer, null, function (_ref27) {
    var isFullWidth = _ref27.isFullWidth,
        helperImageSrc = _ref27.helperImageSrc;
    return helperImageSrc && React.createElement("div", {
      className: getContainerClassName(isFullWidth)
    }, React.createElement("img", {
      src: helperImageSrc,
      className: getImageClassName(isFullWidth)
    }), children);
  });
};

function Layer(_ref28) {
  var children = _ref28.children;
  if (!children) return null;
  var layer = React.createElement("div", {
    className: css(styles$a.layer)
  }, children); // 暂时先只考虑 cover

  return React.createElement(ObjectFitContext.Consumer, null, function (_ref29) {
    var objectFit = _ref29.objectFit;
    return objectFit === 'cover' ? layer : React.createElement(Positioned, null, layer);
  });
}

export default PlayerContainer;
export { Layer, ExternalContext as MessageContext, VideoSourceContext };